import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ExpenseModal from './ExpenseModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter, FaFileAlt, FaEye } from "react-icons/fa";
import { InputGroup, Form, Dropdown } from 'react-bootstrap';
import { FiSearch } from 'react-icons/fi';
import withReactContent from "sweetalert2-react-content";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Select from 'react-select';
const AllExpenseList = () => {
    const [expenses, setExpenses] = useState([]);
    const [instances, setInstances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedExpenseId, setSelectedExpenseId] = useState(null);
    const [selectedExpenseData, setSelectedExpenseData] = useState(null);
    const [errors, setErrors] = useState({});
    const didFetchRef = useRef(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { id } = useParams();
    const [industries, setIndustries] = useState([]);
    const { roles, permissions } = useAuth();
    const WithDeletePermission = withPermission(({ children }) => children, ['expense-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['expense-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['expense-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [users, setUsers] = useState([]);
    const [projectFilter, setProjectFilter] = useState('');
    const [expenseTypeFilter, setExpenseTypeFilter] = useState('');
    const [userFilter, setUserFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null); // Controls which filter dropdown is open
    const [showDropdown, setShowDropdown] = useState(false);
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const [showSummary, setShowSummary] = useState(false);

    const [showSummaryBox, setShowSummaryBox] = useState(true);
    const [attachmentFilter, setAttachmentFilter] = useState('all'); // 'all', 'with', 'without'
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [summaryFilter, setSummaryFilter] = useState('all'); // 'all', 'taxable', 'non-taxable'
    const [filteredExpenses, setFilteredExpenses] = useState([]);
    const [hasInitialLoad, setHasInitialLoad] = useState(false);
    const [sourceFilter, setSourceFilter] = useState([]);
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
    const [vendors, setVendors] = useState([]);
    const [vendorFilter, setVendorFilter] = useState('');
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedEndYear, setSelectedEndYear] = useState(null);
    const [dateRangeFilter, setDateRangeFilter] = useState('yearly');

    const handleDateRangeChange = (value) => {
        setDateRangeFilter(value);
        const now = dayjs();
        if (value === 'yearly') {
            setSelectedYear(null);
            setSelectedEndYear(null);
            setStartDateFilter('');
            setEndDateFilter('');
        }
    };

    const handleSourceFilterChange = (source) => {
        if (sourceFilter.includes(source)) {
            setSourceFilter(prev => prev.filter(item => item !== source));
        } else {
            setSourceFilter(prev => [...prev, source]);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {

            // fetchIndustries();
            didFetchRef.current = true;
        }
    }, [currentPage]);
    const [accountStatus, setAccountStatus] = useState('all');
    // useEffect(() => {
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     debounceTimeoutRef.current = setTimeout(() => {
    //         fetchExpenses({
    //             page: 1,
    //             search: searchQuery,
    //             project: projectFilter,  // ✅ Always send filters if selected
    //             expenseType: expenseTypeFilter,
    //             user: userFilter,
    //             type: typeFilter,
    //         });
    //     }, searchQuery ? 1500 : 0);

    //     return () => clearTimeout(debounceTimeoutRef.current);
    // }, [searchQuery, projectFilter, expenseTypeFilter, userFilter, typeFilter]);
    // useEffect(() => {
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     debounceTimeoutRef.current = setTimeout(() => {
    //         fetchExpenses({
    //             page: 1,
    //             search: searchQuery,
    //             project: projectFilter,
    //             expenseType: expenseTypeFilter,
    //             user: userFilter,
    //             type: typeFilter,
    //             startDate: startDateFilter,
    //             endDate: endDateFilter,
    //             attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
    //             taxType: summaryFilter
    //         });
    //     }, searchQuery ? 1500 : 0);

    //     return () => clearTimeout(debounceTimeoutRef.current);
    // }, [
    //     searchQuery,
    //     projectFilter,
    //     expenseTypeFilter,
    //     userFilter,
    //     typeFilter,
    //     startDateFilter,
    //     endDateFilter,
    //     attachmentFilter,
    //     summaryFilter
    // ]);


    const calculateSummary = (expenseList) => {
        if (!expenseList || expenseList.length === 0) {
            setSummaryData({
                taxable: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 },
                nonTaxable: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 },
                overall: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 }
            });
            return;
        }

        let taxable = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };
        let nonTaxable = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };
        let overall = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };

        expenseList.forEach(expense => {
            const amount = parseFloat(expense.amount) || 0;
            const totalAmount = parseFloat(expense.total_amount) || amount;
            let taxAmount = 0;

            if (expense.tax_type === 'taxable') {
                // Use saved vat_amount if available, otherwise calculate using tax% (default 5%)
                const amountWithoutTax = parseFloat(expense.amount_without_tax) || amount;
                const taxRate = parseFloat(expense.tax || 5) / 100;
                taxAmount = (expense.vat_amount !== null && expense.vat_amount !== undefined)
                    ? parseFloat(expense.vat_amount)
                    : (amountWithoutTax * taxRate);

                taxable.count++;
                taxable.totalAmount += amountWithoutTax;
                taxable.totalTax += taxAmount;
                taxable.totalAfterTax += totalAmount;
            } else {
                // For non-taxable items, no VAT
                nonTaxable.count++;
                nonTaxable.totalAmount += amount;
                nonTaxable.totalTax += 0;
                nonTaxable.totalAfterTax += amount;
            }

            overall.count++;
            overall.totalAmount += expense.tax_type === 'taxable' ? (parseFloat(expense.amount_without_tax) || amount) : amount;
            overall.totalTax += taxAmount;
            overall.totalAfterTax += totalAmount;
        });

        setSummaryData({
            taxable,
            nonTaxable,
            overall
        });
    };




    // Remove applyLocalFilters function - we don't need it anymore

    // Update clearAllFilters function
    const applyFilters = () => {
        setCurrentPage(1);

        fetchExpenses({
            page: 1,
            search: searchQuery,
            project: projectFilter,
            expenseType: expenseTypeFilter,
            user: userFilter,
            vendor: vendorFilter,
            type: typeFilter,
            startDate: startDateFilter,
            endDate: endDateFilter,
            attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
            taxType: summaryFilter,
            source: sourceFilter,
            paymentStatus: statusFilter
        });
        setHasInitialLoad(true); // Mark that data has been loaded at least once
    };

    const clearAllFilters = () => {
        setStartDateFilter('');
        setEndDateFilter('');
        setAttachmentFilter('all');
        setSummaryFilter('all');
        setStatusFilter('all');
        setSearchQuery('');
        setProjectFilter('');
        setExpenseTypeFilter('');
        setUserFilter('');
        setVendorFilter('');
        setTypeFilter('');
        setSourceFilter([]);
        setCurrentPage(1);

        // Clear the data when clearing filters
        setExpenses([]);
        setSummaryData({
            total_amount: 0,
            total_vat: 0,
            grand_total: 0,
            total_count: 0,
            taxable_count: 0,
            non_taxable_count: 0
        });
        setHasInitialLoad(false);
    };
    // Update handlePageClick to include all filters
    const handlePageClick = ({ selected }) => {
        const newPage = selected + 1;
        fetchExpenses({
            page: newPage,
            search: searchQuery,
            project: projectFilter,
            expenseType: expenseTypeFilter,
            user: userFilter,
            vendor: vendorFilter,
            type: typeFilter,
            startDate: startDateFilter,
            endDate: endDateFilter,
            attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
            taxType: summaryFilter,
            source: sourceFilter,
            paymentStatus: statusFilter
        });
    };

    // NEW FUNCTION: Format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };
    const MySwal = withReactContent(Swal);

    const showToast = (message, type = "error") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };

    const showToast1 = (message, type = "show") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const [summaryData, setSummaryData] = useState({
        total_amount: 0,
        total_vat: 0,
        total_adjustment: 0,
        total_wps_charge: 0,
        total_wps_vat: 0,
        total_paid: 0,
        total_unpaid: 0,
        total_balance: 0,
        grand_total: 0,
        total_count: 0,
        taxable_count: 0,
        non_taxable_count: 0
    });

    const isSalarySearch = (Array.isArray(sourceFilter) ? (sourceFilter.includes('salary') || sourceFilter.length === 0) : (sourceFilter === 'salary' || !sourceFilter || sourceFilter === 'all')) || searchQuery?.toLowerCase().includes('employee salary') ||
        expenseTypes.find(t => t.id?.toString() === expenseTypeFilter?.toString())?.name?.toLowerCase().includes('employee salary');

    const isStandardSearch = (Array.isArray(sourceFilter) ? (sourceFilter.includes('direct') || sourceFilter.includes('pettycash')) : (sourceFilter === 'direct' || sourceFilter === 'pettycash')) || (sourceFilter.length === 0);


    const fetchExpenses = async ({
        page = 1,
        search = '',
        project = '',
        expenseType = '',
        user = '',
        vendor = '',
        type = '',
        startDate = '',
        endDate = '',
        attachment = '',
        taxType = '',
        source = 'all',
        paymentStatus = 'all'
    } = {}) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = new URLSearchParams();
            params.append('page', page);

            // Apply ALL filters to the API call
            if (search) params.append('search', search);
            if (project === 'no-project') {
                params.append('no_project', 'true');
            } else if (project) {
                params.append('project_id', project);
            }
            if (expenseType) params.append('expense_type_id', expenseType);
            if (user) params.append('user_id', user);
            if (vendor) params.append('vendor_id', vendor);
            if (startDate) params.append('from_date', startDate);
            if (endDate) params.append('to_date', endDate);
            if (type) params.append('tax_type', type);
            if (attachment === 'without') {
                params.append('attachment_null', 'true');
            } else if (attachment === 'with') {
                params.append('attachment_not_null', 'true');
            }
            if (taxType && taxType !== 'all') {
                params.append('tax_type', taxType);
            }
            if (Array.isArray(source) && source.length > 0) {
                params.append('source', source.join(','));
            } else if (source && source !== 'all' && !Array.isArray(source)) {
                params.append('source', source);
            }
            if (paymentStatus && paymentStatus !== 'all') {
                params.append('payment_status', paymentStatus);
            }

            const response = await axios.get(`${backendUrl}/api/expense?${params.toString()}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Extract data and summary from response
            const expenseData = response.data.data?.data || [];
            const summary = response.data.summary || {
                total_amount: 0,
                total_vat: 0,
                grand_total: 0,
                total_count: 0,
                taxable_count: 0,
                non_taxable_count: 0
            };

            const totalPages = response.data.data?.last_page || 1;
            const currentPage = response.data.data?.current_page || 1;

            setExpenses(expenseData);

            // If it's a salary search, ensure we include WPS totals from the backend
            if (isSalarySearch) {
                summary.total_wps_vat = summary.total_wps_vat || 0;
                summary.total_wps_charge = summary.total_wps_charge || 0;

                // If it's ONLY salary search, we can use total_wps_vat as primary VAT
                // but if it's mixed, we should keep them separate.
                if (sourceFilter.length === 1 && sourceFilter.includes('salary')) {
                    summary.total_vat = summary.total_wps_vat;
                }
            }

            setSummaryData(summary);
            setPageCount(totalPages);
            setCurrentPage(currentPage);

            // Diagnostic logging for debugging discrepancies
            const debugData = expenseData.map(e => {
                const id = e.id || e.expense_id || e.pe_id || e.ID;
                const narration = e.narration || e.description || e.remarks || "No Narration";
                const amount = e.total_amount || e.amount || e.total || e.Amount;
                
                return { 
                    id, 
                    narration, 
                    amount: Number(amount) || 0,
                    payment_status: e.payment_status 
                };
            });
            // 1. Save the current page data (for quick reference)
            localStorage.setItem('debugAllExpenses_Page', JSON.stringify(debugData));

            // 2. BACKGROUND FETCH: Get the full list for the Comparison Tool
            // We use the exact same filters (params) but remove pagination
            localStorage.setItem('debugAllExpenses_Status', 'fetching');
            const fullAuditParams = new URLSearchParams(params.toString());
            fullAuditParams.delete('page');
            fullAuditParams.delete('per_page');
            fullAuditParams.delete('perPage');

            axios.get(`${backendUrl}/api/expense?${fullAuditParams.toString()}`, {
                headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin }
            }).then(auditRes => {
                const allData = Array.isArray(auditRes.data.data) ? auditRes.data.data : (auditRes.data.data?.data || []);
                if (allData.length > 0) console.log("🛠️ DEBUG [AllExpenseList] KEYS:", Object.keys(allData[0]));

                const fullDebugData = allData
                    .filter(e => e.reconciliation_status !== 'reversed' && e.expense_reconciliation_status !== 'reversed')
                    .map(e => {
                        // Strict check to avoid skipping "0" amounts
                        const getVal = (v1, v2, v3) => (v1 !== null && v1 !== undefined) ? v1 : ((v2 !== null && v2 !== undefined) ? v2 : (v3 || 0));
                        
                        return {
                            id: e.id || e.expense_id,
                            date: (e.date || e.expense_date || "").substring(0, 10),
                            narration: (e.narration || e.description || "No Narration").trim().toLowerCase(),
                            amount: Number(getVal(e.total_amount, e.total, e.amount)),
                            balance: Number(e.balance_amount || 0),
                            paid: Number(e.paid_amount || 0),
                            net: Number(e.amount_excl_vat || 0),
                            total_aed: Number(e.total_aed || 0),
                            payment_status: e.payment_status
                        };
                    });
                localStorage.setItem('debugAllExpenses', JSON.stringify(fullDebugData));
                localStorage.setItem('debugAllExpenses_Status', 'ready');
                console.log(`✅ [Audit Tool] Full list of ${fullDebugData.length} items captured.`);
            }).catch(err => {
                localStorage.setItem('debugAllExpenses_Status', 'error');
                console.error("Audit fetch failed:", err);
            });
  
            // Shared Comparison Utility
            window.compareExpenses = () => {
                const status = localStorage.getItem('debugAllExpenses_Status');
                if (status === 'fetching') {
                    console.log("%c⏳ Please wait... Still fetching the full list of expenses (up to 1000). Try again in 2 seconds.", "color: orange; font-weight: bold;");
                    return;
                }

                const report = JSON.parse(localStorage.getItem('debugExpenseReport') || '[]');
                const list = JSON.parse(localStorage.getItem('debugAllExpenses') || '[]');
                const ledger = JSON.parse(localStorage.getItem('debugLedgerStatement') || '[]');
                
                const reportIds = report.map(e => e.id);
                const listIds = list.map(e => e.id);

                console.clear();
                console.log("%c🔍 [CROSS-TAB AUDIT RESULT]", "color: white; background: blue; padding: 5px; font-weight: bold; font-size: 16px;");
                console.log(`Report: ${report.length} | List: ${list.length}`);

                const missedInList = report.filter(e => {
                    if (e.id && listIds.includes(e.id)) return false;
                    
                    return !list.some(l => {
                        const d1 = new Date(e.date);
                        const d2 = new Date(l.date);
                        const daysDiff = Math.abs(d1 - d2) / (1000 * 60 * 60 * 24);
                        const dateMatch = daysDiff <= 2;

                        const amountMatch = Math.abs(l.amount - e.amount) < 1.00;
                        const balanceMatch = Math.abs(l.balance - e.amount) < 1.00;
                        const paidMatch = Math.abs(l.paid - e.amount) < 1.00;
                        const netMatch = Math.abs(l.net - e.amount) < 1.00;
                        const aedMatch = Math.abs(l.total_aed - e.amount) < 1.00;
                        const smartMatch = amountMatch || balanceMatch || paidMatch || netMatch || aedMatch;

                        const narrationMatch = l.narration && e.narration && l.narration.substring(0, 5) === e.narration.substring(0, 5);

                        return dateMatch && (smartMatch || (Math.abs(l.amount - e.amount) < 50.00 && narrationMatch));
                    });
                });

                const extraInList = list.filter(l => {
                    if (l.id && reportIds.includes(l.id)) return false;
                    return !report.some(e => {
                        const d1 = new Date(e.date);
                        const d2 = new Date(l.date);
                        const daysDiff = Math.abs(d1 - d2) / (1000 * 60 * 60 * 24);
                        return daysDiff <= 2 && (Math.abs(e.amount - l.amount) < 50.00 || Math.abs(e.amount - l.balance) < 50.00);
                    });
                });

                if (missedInList.length > 0) {
                    console.log(`%c❌ Items in Report missing from List (${missedInList.length}):`, "color: red; font-weight: bold;");
                    missedInList.forEach(e => {
                        // SEARCH ENTIRE LIST for the amount if no date-match found
                        const globalMatch = list.find(l => Math.abs(l.amount - e.amount) < 1.00 || Math.abs(l.balance - e.amount) < 1.00);
                        const matchInfo = globalMatch ? ` | FOUND ON DIFFERENT DATE: ${globalMatch.date} (${globalMatch.payment_status})` : " | Truly not in List";
                        console.log(`   - [${e.date}] "${e.narration}" | Amt: ${e.amount}${matchInfo}`);
                    });
                }

                if (extraInList.length > 0) {
                    console.log(`%c➕ Items in List missing from Report (${extraInList.length}):`, "color: blue; font-weight: bold;");
                    extraInList.forEach(l => {
                        console.log(`   - [${l.date}] "${l.narration}" | Amt: ${l.amount} (${l.payment_status})`);
                    });
                }
                
                if (missedInList.length === 0 && extraInList.length === 0) {
                    console.log("%c✅ Perfect Match: All Report & List items are synchronized!", "color: green; font-weight: bold;");
                }

                if (ledger.length > 0) {
                    console.log(`%c📑 [LEDGER AUDIT: EXPENSES vs JOURNALS]`, "color: white; background: purple; padding: 5px; font-weight: bold;");
                    
                    const orphanJournals = ledger.filter(l => {
                        const inReport = report.some(e => Number(e.journal_id) === Number(l.id));
                        const inList = list.some(e => Number(e.journal_id) === Number(l.id));
                        if (inReport || inList) return false;
                        return !report.some(e => Math.abs(e.amount - l.amount) < 0.05 && e.narration?.substring(0, 5) === l.narration?.substring(0, 5));
                    });

                    const ledgerIds = ledger.map(l => Number(l.id));
                    const missingInLedger = report.filter(e => e.journal_id && !ledgerIds.includes(Number(e.journal_id)));

                    if (orphanJournals.length > 0) {
                        console.log(`%c⚠️ Found ${orphanJournals.length} Ledger entries NOT linked to any Expense:`, "color: orange; font-weight: bold;");
                        orphanJournals.forEach(l => console.log(`   - [ID: ${l.id}] "${l.narration}" | Amt: ${l.amount.toFixed(2)}`));
                    }

                    if (missingInLedger.length > 0) {
                        console.log(`%c🚨 Found ${missingInLedger.length} Expenses whose Journal entries are MISSING from this Ledger view:`, "color: red; font-weight: bold;");
                        missingInLedger.forEach(e => console.log(`   - [Jrn ID: ${e.journal_id}] "${e.narration}" | Amt: ${e.amount.toFixed(2)} (${e.payment_status})`));
                    }

                    if (orphanJournals.length === 0 && missingInLedger.length === 0) {
                        console.log("✅ All Expenses match the Ledger entries perfectly.");
                    }
                }
            };

            console.log("📊 [AllExpenseList] Data Saved. Type 'compareExpenses()' to run audit.");

        } catch (error) {
            console.error('Error fetching expenses:', error);
        }
    };


    // const fetchExpenses = async ({ page = 1, search = '', project = '', expenseType = '', user = '', type = '', narration = '', date = '' } = {}) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const origin = localStorage.getItem('user-origin');
    //         const token = userInfo?.token;

    //         // Construct params dynamically
    //         let params = new URLSearchParams();
    //         params.append('page', page);

    //         // Apply search query globally
    //         if (search) params.append('search', search);
    //         if (project === 'no-project') {
    //             // Special case for filtering expenses with no project
    //             params.append('no_project', 'true');
    //         } else if (project) {
    //             params.append('project_id', project);
    //         }
    //         if (expenseType) params.append('expense_type_id', expenseType);
    //         if (user) params.append('user_id', user);
    //         if (dateRange?.from) params.append('from_date', dateRange.from);
    //         if (dateRange?.to) params.append('to_date', dateRange.to);
    //         if (type) params.append('tax_type', type);
    //         if (narration) params.append('narration', narration);

    //         const response = await axios.get(`${backendUrl}/api/expense?${params.toString()}`, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Tenant-Origin': origin,
    //             },
    //         });

    //         console.log('Expense Response:', response.data);
    //         const expenseData = response.data.data?.data || [];



    //         // Extract pagination info correctly
    //         const totalPages = response.data.data?.last_page || 1;
    //         const currentPage = response.data.data?.current_page || 1;

    //         setExpenses(expenseData);
    //         setPageCount(totalPages);
    //         setCurrentPage(currentPage);
    //     } catch (error) {
    //         console.error('Error fetching expenses:', error);
    //     }
    // };



    const fetchExpenseTypes = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/expense-type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,


            });
            const sortedExpenseTypes = (response.data.expense || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setExpenseTypes(sortedExpenseTypes);



        } catch (error) {
            console.error('Error fetching expenseTypes:', error);
        }
    };
    const fetchUsers = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            const sortedUsers = (response.data.users || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setUsers(sortedUsers);



        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const [projects, setProjects] = useState([]);

    const fetchProjects = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const sortedProjects = (response.data.Data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setProjects(sortedProjects);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setVendors(response.data.vendors || []);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    useEffect(() => {
        fetchProjects();
        fetchExpenseTypes();
        fetchUsers();
        fetchVendors();
    }, []);

    const totalExpenseAmount = expenses.reduce((sum, item) => sum + Number(item.amount), 0);

    // const addExpense = async (newExpense) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;

    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const token = userInfo?.token;

    //         const response = await axios.post(`${backendUrl}/api/expense`, newExpense, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //             },
    //         });

    //         const createdExpense = response.data?.data;


    //         if (createdExpense) {
    //             setExpenses((prevExpense) => Array.isArray(prevExpense) ? [...prevExpense, createdExpense] : [createdExpense]);
    //         } else {
    //             console.error('Creation failed, no data returned.');
    //         }

    //         handleCloseModal();
    //     } catch (error) {
    //         if (error.response?.data?.errors) {
    //             return error.response.data.errors;
    //         } else {
    //             console.error('Error adding expense:', error);
    //         }
    //     }
    // };


    const fetchAllProjectExpenses = async (projectId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/expense?project_id=${projectId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            return response.data?.data || [];
        } catch (error) {
            console.error("❌ Error fetching full expenses list:", error);
            return [];
        }
    };


    const addExpense = async (newExpenseFormData) => {
        console.log("🚀 newExpense before submission (FormData):", newExpenseFormData);

        const newExpense = Object.fromEntries(newExpenseFormData.entries());
        console.log("📜 Converted newExpense Object:", newExpense);

        const selectedProjectId = newExpense.project_id ? String(newExpense.project_id).trim() : "";
        const isExternal = newExpense.type?.toLowerCase() === 'external';
        // if (!selectedProjectId && !isExternal) {
        //     Swal.fire({ icon: "error", text: "Please select a project before adding expenses." });
        //     return;
        // }

        const selectedProject = projects.find(p => String(p.id).trim() === selectedProjectId);
        if (!isExternal) {

            // if (!selectedProject) {
            //     Swal.fire({ icon: "error", text: `Invalid project selection (${selectedProjectId}).` });
            //     return;
            // }


            // ✅ Fetch full expenses list for the selected project
            const fullProjectExpenses = await fetchAllProjectExpenses(selectedProjectId);
            console.log("📊 Full Expenses for Selected Project:", fullProjectExpenses);

            // const expenditureLimit = parseFloat(selectedProject.expenditure_amount || 0);
            const newExpenseAmount = parseFloat(newExpense.amount || 0);

            // ✅ Calculate total including new expense
            const updatedTotalExpenseAmount = [...fullProjectExpenses, newExpense]
                .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

            // console.log("💰 Expenditure Limit:", expenditureLimit);
            console.log("✅ Corrected Total with New Expense:", updatedTotalExpenseAmount);

            // if (updatedTotalExpenseAmount > expenditureLimit) {
            //     Swal.fire({
            //         toast: true,
            //         position: 'top-end',
            //         icon: 'warning',
            //         text: `Budget Exceeded! Adding this expense will exceed  ${expenditureLimit}.`,
            //         showConfirmButton: false,
            //         timer: 4000,
            //         timerProgressBar: false
            //     });
            //     return;
            // }
        }

        // ✅ Proceed with adding the expense
        try {
            console.log("📡 Sending API Request...");
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/expense`, newExpense, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdExpense = response.data?.data;
            if (createdExpense) {
                console.log("✅ Expense Created:", createdExpense);
                setExpenses((prevExpense) =>
                    Array.isArray(prevExpense) ? [...prevExpense, createdExpense] : [createdExpense]
                );
                // if (createdExpense.user_id) {
                //     await runDoubleEntry(createdExpense);
                // }
                await runDoubleEntry(createdExpense);

            }

            handleCloseModal();
            showToast1("Expense Added Successfully.");

        } catch (error) {
            console.error(error);
            throw error;
            console.error("❌ Error adding expense:", error);
        }
    };



    const editExpense = async (expenseId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const webzashBaseUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
            const APIkey = process.env.REACT_APP_API_KEY || '';

            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data', // Ensure file uploads work
                    'Tenant-Origin': origin,
                },
            };

            const response = await axios.post(`${backendUrl}/api/expense/${expenseId}?_method=PUT`, updatedData, config);

            console.log('Updated Expense Response:', response.data);

            const updatedExpense = response.data?.data;
            if (!updatedExpense) {
                console.error('Update failed, no data returned.');
                return;
            }

            // Step 2: Delete old Webzash journal if exists
            if (updatedExpense.journal_id) {
                try {
                    await axios.post(
                        `${webzashBaseUrl}/api/entries/delete/journal/${updatedExpense.journal_id}`,
                        {}, // empty body
                        {
                            headers: {
                                'x-api-key': APIkey,
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            }
                        }
                    );

                } catch (err) {
                    console.warn("⚠️ Failed to delete old journal entry. Proceeding...");
                }
            }
            updatedExpense.journal_id = null;

            // Step 3: Recreate Webzash entry
            await runDoubleEntry(updatedExpense);

            if (updatedExpense) {
                setExpenses((prevExpenses) =>
                    prevExpenses.map((expense) =>
                        expense.id === expenseId ? { ...expense, ...updatedExpense } : expense
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
            showToast1("Expense Updated Successfully.");

        } catch (error) {
            console.error(error);
            throw error;
        }
    };



    const deleteExpense = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    const webzashBaseUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
                    const APIkey = process.env.REACT_APP_API_KEY || '';
                    const expenseRes = await axios.get(`${backendUrl}/api/expense/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    const journalId = expenseRes?.data?.journal_id;
                    const isPaid = expenseRes?.data?.is_paid === '1' || expenseRes?.data?.is_paid === true;

                    // Check if expense is already paid
                    if (isPaid) {
                        // Show warning toast
                        showToast(
                            "This expense has already been paid. Please delete the payment transaction first before deleting the expense.",
                            "warning"
                        );
                        return; // Stop the deletion process
                    }

                    // Step 2: Delete journal if exists
                    if (journalId) {
                        try {
                            await axios.post(
                                `${webzashBaseUrl}/api/entries/delete/journal/${journalId}`,
                                {}, // empty body
                                {
                                    headers: {
                                        'x-api-key': APIkey,
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    }
                                }
                            );
                        } catch (err) {
                            console.warn("⚠️ Journal delete failed but continuing with expense delete.");
                        }
                    }

                    await axios.delete(` ${backendUrl}/api/expense/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setExpenses(expenses.filter(expense => expense.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The expense has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting expense:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete expense. Please try again.",
                        "error"
                    );
                }
            }
        });
    };
    const [isEditMode, setIsEditMode] = useState(false);


    // const handleShowModal = (expenseId = null) => {
    //     console.log("handleShowModal called with expenseId:", expenseId);

    //     if (expenseId !== null) {
    //         const expenseToEdit = expenses.find(expense => expense.id === expenseId);
    //         setSelectedExpenseData(expenseToEdit || null);
    //         setSelectedExpenseId(expenseId);
    //     } else {
    //         setSelectedExpenseData(null);
    //         setSelectedExpenseId(null);
    //         setErrors({});
    //     }

    //     setShowModal(true);
    // };

    // parent
    const handleShowModal = (expenseId = null, mode = "view") => {
        console.log("handleShowModal called with expenseId:", expenseId, "mode:", mode);

        if (expenseId !== null) {
            const expenseToEdit = expenses.find(expense => expense.id === expenseId);
            setSelectedExpenseData(expenseToEdit || null);
            setSelectedExpenseId(expenseId);
        } else {
            setSelectedExpenseData(null);
            setSelectedExpenseId(null);
            setErrors({});
        }

        // 👇 set mode here
        setIsEditMode(mode === "edit");

        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedExpenseId(null);
        setSelectedExpenseData(null);
        setErrors({});
        setIsEditMode(false);
    };

    // const handlePageClick = ({ selected }) => {
    //     const newPage = selected + 1;
    //     setCurrentPage(newPage);
    //     fetchExpenses({
    //         page: newPage,
    //         search: searchQuery,
    //         project: projectFilter,
    //         expenseType: expenseTypeFilter,
    //         user: userFilter
    //     });
    // };

    const handleFilterChange = (filterType, value) => {
        setCurrentPage(1);

        if (filterType === 'project') setProjectFilter(value);
        if (filterType === 'expenseType') setExpenseTypeFilter(value);
        if (filterType === 'user') setUserFilter(value);
        if (filterType === 'type') setTypeFilter(value);
        if (filterType === 'paymentStatus') setStatusFilter(value);
        if (filterType === 'vendor') setVendorFilter(value);


        setFilterDropdown(null); // Close dropdown after selection
    };





    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };
    const applyDateFilter = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchExpenses();
    };
    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" }); // Reset date inputs
    };
    // const backendUrl = 'http://localhost/webzash/api';

    const generateUniqueEntryNumber = () => {
        const timestamp = Date.now(); // e.g., 1717512958000
        const random = Math.floor(100 + Math.random() * 900); // 3-digit random
        return parseInt(`${timestamp}${random}`.slice(-10)); // limit to 10 digits
    };

    const runDoubleEntry = async (expenseData) => {
        const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
        const backendUrl = `${API}/api`;
        console.log("url", backendUrl);

        const token = localStorage.getItem("token");
        const headers = {
            'x-api-key': process.env.REACT_APP_API_KEY,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        try {
            const groupRes = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = groupRes.data;
            if (!Array.isArray(allGroups)) {
                showToast("❌ Failed to load groups");
                return;
            }

            const ledgerRes = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerRes.data?.data;
            if (!Array.isArray(allLedgers)) {
                showToast("❌ Failed to load ledgers");
                return;
            }

            await createDoubleEntryForExpense(expenseData, allGroups, allLedgers, backendUrl, headers);
        } catch (error) {
            console.error("❌ Error in double entry logic:", error);
        }
    };

    // const createDoubleEntryForExpense = async (expense, allGroups, allLedgers, backendUrl, headers) => {
    //      const enteredCurrency = expense.vendor_currency || "AED";

    // // Get the vendor's actual currency from the vendor object
    // const vendor = expense.vendor;
    // const vendorActualCurrency = vendor?.currency || "AED";

    // // Determine if conversion is needed
    // // ALWAYS record in AED in Webzash accounts
    // let conversionRate = 1;
    // let needsConversion = false;

    // // If user entered amount in USD, convert to AED for accounting
    // if (enteredCurrency === "USD") {
    //     conversionRate = 3.67; // Convert USD to AED (multiply by 3.67)
    //     needsConversion = true;
    //     console.log(`Converting USD to AED: User entered USD, converting to AED for accounts`);
    // } 
    // // If user entered AED, no conversion needed (accounts already in AED)
    // else if (enteredCurrency === "AED") {
    //     conversionRate = 1;
    //     needsConversion = false;
    //     console.log(`No conversion needed: User entered AED, accounts in AED`);
    // }

    // console.log(`Vendor Currency: ${vendorActualCurrency}`);
    // console.log(`User Entered Currency: ${enteredCurrency}`);
    // console.log(`Conversion Rate: ${conversionRate}, Needs Conversion: ${needsConversion}`);

    //     const amount = parseFloat(expense.amount);
    //     const expenseType = expense.expense_type;
    //     const adjustmentAmount = expense.adjustment_amount ? parseFloat(expense.adjustment_amount) : 0;

    //     const user = expense.user;

    //     if (!expenseType || (!vendor && !user)) {
    //         showToast("❌ Missing expense type or vendor/user.");
    //         return;
    //     }

    //     // ========== STEP 1: Ensure expense category group exists ==========
    //     // STEP 1: Ensure expense category group exists
    //     const categoryName = expenseType.category?.name;
    //     const categoryGroupId = expenseType.category?.group_id; // 👈 Must be passed from backend
    //     let expenseGroup = allGroups.find(g => g.Group?.name === categoryName)?.Group;

    //     if (!expenseGroup) {
    //         if (!categoryGroupId) {
    //             showToast("❌ Category is missing a group_id. Cannot create group.");
    //             return;
    //         }

    //         // Check if the parent group exists in allGroups
    //         const parentGroup = allGroups.find(g => g.Group?.id === categoryGroupId)?.Group;

    //         if (!parentGroup) {
    //             showToast("❌ Parent group for this category not found.");
    //             return;
    //         }

    //         const groupPayload = {
    //             Group: {
    //                 name: categoryName,
    //                 parent_id: categoryGroupId, // ✅ Use the correct parent group (Direct/Indirect/Purchase)
    //                 affect_gross: 1,
    //                 code: null,
    //             }
    //         };

    //         const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //         const groupId = res.data?.id;

    //         if (!groupId) {
    //             showToast("❌ Failed to create group for this category.");
    //             return;
    //         }

    //         expenseGroup = { id: parseInt(groupId), name: categoryName };
    //     }

    //     let adjustmentLedgerId = null;
    //     if (expense.tax_type === 'taxable' && adjustmentAmount > 0) {
    //         const adjustmentLedgerName = "Adjustment Charges";
    //         const existingAdjustmentLedger = allLedgers.find(l => l.Ledger?.name === adjustmentLedgerName);

    //         if (existingAdjustmentLedger) {
    //             adjustmentLedgerId = existingAdjustmentLedger.Ledger.id;
    //         } else {
    //             let bankFinGroup = allGroups.find(g => {
    //                 const normalized = g.Group?.name?.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
    //                 return normalized === "banking and financial charges";
    //             })?.Group;

    //             if (!bankFinGroup) {
    //                 const indirectGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
    //                 if (!indirectGroup) {
    //                     showToast("❌ 'Indirect Expenses' group not found.");
    //                     return;
    //                 }

    //                 const createBankingGroup = await axios.post(`${backendUrl}/groups/add`, {
    //                     Group: {
    //                         name: "Banking and Financial Charges",
    //                         parent_id: indirectGroup.id,
    //                         affect_gross: 1,
    //                         code: null,
    //                     }
    //                 }, { headers });

    //                 const newGroupId = createBankingGroup.data?.id;
    //                 if (!newGroupId) {
    //                     showToast("❌ Failed to create 'Banking and Financial Charges' group.");
    //                     return;
    //                 }

    //                 const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
    //                 allGroups = refresh.data;
    //                 bankFinGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
    //             }

    //             const adjustmentLedgerPayload = {
    //                 Ledger: {
    //                     name: adjustmentLedgerName,
    //                     group_id: bankFinGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "D",
    //                     notes: "Expense adjustment amount",
    //                     code: null,
    //                     type: 0,
    //                     reconciliation: 0,
    //                 }
    //             };

    //             const createLedger = await axios.post(`${backendUrl}/ledgers/add`, adjustmentLedgerPayload, { headers });
    //             adjustmentLedgerId = createLedger.data?.data?.Ledger?.id;
    //         }
    //     }
    //     // ========== NEW STEP: Ensure Deferred Expense ledger exists ==========
    //     const deferredLedgerName = `Deferred Expense`;
    //     let deferredLedger = allLedgers.find(l => l.Ledger?.name === deferredLedgerName);
    //     let deferredLedgerId = null;

    //     if (deferredLedger) {
    //         deferredLedgerId = deferredLedger.Ledger.id;
    //     } else {
    //         const assetGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group
    //             || allGroups.find(g => g.Group?.name === "Assets")?.Group;

    //         if (!assetGroup) {
    //             showToast("❌ 'Current Assets' or 'Assets' group not found.");
    //             return;
    //         }

    //         const ledgerPayload = {
    //             Ledger: {
    //                 name: deferredLedgerName,
    //                 group_id: assetGroup.id,
    //                 op_balance: 0,
    //                 op_balance_dc: "D",
    //                 notes: "Deferred Expense Ledger (auto-created)",
    //                 code: null,
    //                 type: 0,
    //                 reconciliation: 0,
    //             }
    //         };

    //         const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //         deferredLedgerId = res.data?.data?.Ledger?.id;
    //     }


    //     // ========== STEP 2: Ensure expense ledger exists ==========
    //     const expenseLedgerName = expenseType.name;
    //     let debitLedger = allLedgers.find(l => l.Ledger?.name === expenseLedgerName);
    //     let debitLedgerId = null;

    //     if (debitLedger) {
    //         debitLedgerId = debitLedger.Ledger.id;
    //     } else {
    //         const ledgerPayload = {
    //             Ledger: {
    //                 name: expenseLedgerName,
    //                 group_id: expenseGroup.id,
    //                 op_balance: 0,
    //                 op_balance_dc: "D",
    //                 notes: "",
    //                 code: null,
    //                 type: 0,
    //                 reconciliation: 0,
    //             }
    //         };

    //         try {
    //             const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //             debitLedgerId = res.data?.data?.Ledger?.id;
    //         } catch (err) {
    //             const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //             const existing = refresh.data?.data?.find(l => l.Ledger?.name === expenseLedgerName);
    //             debitLedgerId = existing?.Ledger?.id;

    //             if (!debitLedgerId) {
    //                 showToast("❌ Expense ledger exists but ID not found.");
    //                 return;
    //             }
    //         }
    //     }

    //     // ========== STEP 3: Determine credit ledger ==========
    //     let creditLedgerId = null;
    //     let creditLedgerName = "";
    //     let creditLedgerGroupName = "";

    //     if (vendor && user) {
    //         creditLedgerName = user.name;
    //         creditLedgerGroupName = "Loans (Liabilities)";
    //     } else if (vendor) {
    //         creditLedgerName = vendor.name;
    //         creditLedgerGroupName = "Sundry Creditors (Vendors)";
    //     } else if (user) {
    //         creditLedgerName = user.name;
    //         creditLedgerGroupName = "Loans (Liabilities)";
    //     }

    //     // ========== STEP 4: Find or create credit ledger ==========
    //     let creditGroup = allGroups.find(g => g.Group?.name === creditLedgerGroupName)?.Group;

    //     if (!creditGroup) {
    //         const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;

    //         if (!parentLiabilitiesGroup) {
    //             showToast("'Liabilities and Owners Equity' group not found.");
    //             return;
    //         }

    //         const groupPayload = {
    //             Group: {
    //                 name: creditLedgerGroupName,
    //                 parent_id: parentLiabilitiesGroup.id,
    //                 affect_gross: 0,
    //                 code: null
    //             }
    //         };

    //         const groupRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //         const newGroupId = groupRes.data?.id;

    //         if (!newGroupId) {
    //             showToast(`Failed to create group '${creditLedgerGroupName}'.`);
    //             return;
    //         }

    //         const groupRes2 = await axios.get(`${backendUrl}/groups/index`, { headers });
    //         allGroups = groupRes2.data;
    //         creditGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
    //     }

    //     let creditLedger = allLedgers.find(l => l.Ledger?.name === creditLedgerName);
    //     if (creditLedger) {
    //         creditLedgerId = creditLedger.Ledger.id;
    //     } else {
    //         const creditLedgerPayload = {
    //             Ledger: {
    //                 name: creditLedgerName,
    //                 group_id: creditGroup.id,
    //                 op_balance: 0,
    //                 op_balance_dc: "C",
    //                 notes: "",
    //                 code: null,
    //                 type: 0,
    //                 reconciliation: 0,
    //             }
    //         };

    //         try {
    //             const res = await axios.post(`${backendUrl}/ledgers/add`, creditLedgerPayload, { headers });
    //             creditLedgerId = res.data?.data?.Ledger?.id;
    //         } catch (err) {
    //             const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //             const existing = refresh.data?.data?.find(l => l.Ledger?.name === creditLedgerName);
    //             creditLedgerId = existing?.Ledger?.id;

    //             if (!creditLedgerId) {
    //                 showToast(`Ledger '${creditLedgerName}' exists but ID not found.`);
    //                 return;
    //             }
    //         }
    //     }

    //     // ========== STEP 5: Handle vendor-specific cases ==========
    //     let vendorLedgerId = null;
    //     if (vendor && user) {
    //         // Handle vendor ledger creation
    //         const vendorLedgerName = vendor.name;
    //         const vendorGroupName = "Sundry Creditors (Vendors)";

    //         let vendorGroup = allGroups.find(g => g.Group?.name === vendorGroupName)?.Group;
    //         if (!vendorGroup) {
    //             const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
    //             const vendorGroupPayload = {
    //                 Group: {
    //                     name: vendorGroupName,
    //                     parent_id: parentLiabilitiesGroup.id,
    //                     affect_gross: 0,
    //                     code: null,
    //                 }
    //             };
    //             const groupRes = await axios.post(`${backendUrl}/groups/add`, vendorGroupPayload, { headers });
    //             const newGroupId = groupRes.data?.id;
    //             const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
    //             allGroups = refresh.data;
    //             vendorGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
    //         }

    //         let vendorLedger = allLedgers.find(l => l.Ledger?.name === vendorLedgerName);
    //         if (!vendorLedger) {
    //             const vendorLedgerPayload = {
    //                 Ledger: {
    //                     name: vendorLedgerName,
    //                     group_id: vendorGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "C",
    //                     notes: "",
    //                     code: null,
    //                     type: 0,
    //                     reconciliation: 0,
    //                 }
    //             };
    //             const res = await axios.post(`${backendUrl}/ledgers/add`, vendorLedgerPayload, { headers });
    //             vendorLedgerId = res.data?.data?.Ledger?.id;
    //         } else {
    //             vendorLedgerId = vendorLedger.Ledger.id;
    //         }
    //     }

    //     // ========== STEP 6: Calculate amounts ==========
    //     let conversionRate = 1;
    //     if (vendor && vendor.currency === "USD") {
    //         conversionRate = 3.67;
    //     }

    //     let expenseAmount = 0;
    //     let vatAmount = 0;

    //     if (expense.tax_type === 'taxable') {
    //         const baseAmount = parseFloat(expense.amount_without_tax || 0);
    //         expenseAmount = parseFloat((baseAmount * conversionRate).toFixed(2));
    //         vatAmount = parseFloat((expenseAmount * 0.05).toFixed(2));
    //         const convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));

    //     } else {
    //         const baseAmount = parseFloat(expense.amount || 0);
    //         expenseAmount = parseFloat((baseAmount * conversionRate).toFixed(2));
    //         vatAmount = 0;
    //     }

    //     // ========== STEP 7: Handle VAT ledger ==========
    //     let inputVATLedgerId = null;
    //     if (vatAmount > 0) {
    //         let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;

    //         if (!taxAssetGroup) {
    //             const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
    //             const groupPayload = {
    //                 Group: {
    //                     name: "Tax Assets",
    //                     parent_id: parentAssetsGroup.id,
    //                     affect_gross: 0,
    //                     code: null
    //                 }
    //             };
    //             const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //             taxAssetGroup = { id: parseInt(res.data?.id), name: "Tax Assets" };
    //         }

    //         const inputVATLedgerName = "Input VAT";
    //         let inputVATLedger = allLedgers.find(l => l.Ledger?.name === inputVATLedgerName);
    //         if (!inputVATLedger) {
    //             const vatLedgerPayload = {
    //                 Ledger: {
    //                     name: inputVATLedgerName,
    //                     group_id: taxAssetGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "D",
    //                     notes: "",
    //                     code: null,
    //                     type: 0,
    //                     reconciliation: 0,
    //                 }
    //             };
    //             const res = await axios.post(`${backendUrl}/ledgers/add`, vatLedgerPayload, { headers });
    //             inputVATLedgerId = res.data?.data?.Ledger?.id;
    //         } else {
    //             inputVATLedgerId = inputVATLedger.Ledger.id;
    //         }
    //     }


    //     // ========== STEP 8: Build entry items ==========
    //     const entryItems = [];
    //     let ExpenseDebitID = expenseType.is_deferred ? deferredLedgerId : debitLedgerId;
    //     console.log('isdefferd', expenseType.is_deferred);


    //     // 1. Debit expense ledger
    //     entryItems.push({
    //         dc: "D",
    //         // ledger_id: debitLedgerId,
    //         ledger_id: ExpenseDebitID,
    //         dr_amount: expenseAmount.toFixed(2),
    //         cr_amount: null
    //     });

    //     // 2. Debit VAT if applicable
    //     if (vatAmount > 0) {
    //         entryItems.push({
    //             dc: "D",
    //             ledger_id: inputVATLedgerId,
    //             dr_amount: vatAmount.toFixed(2),
    //             cr_amount: null
    //         });
    //     }
    //     const convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));

    //     if (expense.tax_type === 'taxable' && convertedAdjustmentAmount > 0 && adjustmentLedgerId) {
    //         entryItems.push({
    //             dc: "D",
    //             ledger_id: adjustmentLedgerId,
    //             dr_amount: convertedAdjustmentAmount.toFixed(2),
    //             cr_amount: null
    //         });
    //     }

    //     // 3. Handle vendor/user combinations
    //     if (vendor && user) {
    //         // Vendor-to-User transaction requires:
    //         // 1. Credit Vendor
    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: vendorLedgerId,
    //             dr_amount: null,
    //             cr_amount: (expenseAmount + vatAmount + convertedAdjustmentAmount).toFixed(2)
    //         });

    //         // 2. Debit Vendor, Credit User
    //         entryItems.push({
    //             dc: "D",
    //             ledger_id: vendorLedgerId,
    //             dr_amount: (expenseAmount + vatAmount + convertedAdjustmentAmount).toFixed(2),
    //             cr_amount: null
    //         });

    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: creditLedgerId,
    //             dr_amount: null,
    //             cr_amount: (expenseAmount + vatAmount + convertedAdjustmentAmount).toFixed(2)
    //         });
    //     } else {
    //         // Regular case - single credit entry
    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: creditLedgerId,
    //             dr_amount: null,
    //             cr_amount: (expenseAmount + vatAmount + convertedAdjustmentAmount).toFixed(2)
    //         });
    //     }
    //     if (!creditLedgerId) {
    //         showToast("❌ Credit ledger not found. Cannot proceed.");
    //         return;
    //     }

    //     // ========== STEP 9: Create final payload ==========
    //     const entryPayload = {
    //         Entry: {
    //             tag_id: null,
    //             number: generateUniqueEntryNumber(),
    //             date: expense.date,
    //             narration: expense.narration || `Expense: ${expenseType.name} by ${vendor ? vendor.name : user?.name ?? ''}`,
    //             client_id: parseInt(expense?.client_id) || parseInt(expense?.project?.client_id) || null,
    //             user_id: parseInt(user?.id || expense?.user_id) || null,
    //             project_id: parseInt(expense?.project_id) || null,
    //             is_import: true,

    //         },
    //         Entryitem: entryItems
    //     };

    //     // ========== STEP 10: Submit entry ==========
    //     try {
    //         const res = await axios.post(`${backendUrl}/entries/add/journal`, entryPayload, { headers });
    //         if (res.data?.status === 'error') {
    //             showToast(`❌ ${res.data.message || 'Failed to create Expense.'}`);
    //             return;
    //         }
    //         const webzashEntryId = res.data.entry_id;

    //         const backend = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const origin = localStorage.getItem('user-origin');
    //         const token = userInfo?.token;

    //         // Correct way to send data and headers
    //         await axios.post(
    //             `${backend}/api/expense/${expense.id}?_method=PUT`,
    //             { journal_id: webzashEntryId },
    //             {
    //                 headers: {
    //                     'Authorization': `Bearer ${token}`,
    //                     'Tenant-Origin': origin,
    //                 }
    //             }
    //         );
    //         showToast1("✅ Expense Added Successfully.");
    //     } catch (err) {
    //         showToast("❌ Failed to create Expense.");
    //         console.error(err);
    //     }
    // };


    const createDoubleEntryForExpense = async (expense, allGroups, allLedgers, backendUrl, headers) => {
        // Get the entered currency from the expense data (this is what user selected in dropdown)
        const enteredCurrency = expense.vendor_currency || "AED";
        const isSalaryExpense = expense.type === 'salary' || expense.is_salary_expense === true;

        if (isSalaryExpense) {
            console.log('📝 Processing Salary Expense Entry');
            await createSalaryExpenseEntry(expense, allGroups, allLedgers, backendUrl, headers);
            return;
        }

        // Check for deferred expense
        const isDeferredExpense = expense.type === 'deferred';
        if (isDeferredExpense) {
            console.log('📝 Processing Deferred Expense Entry');
            await createDeferredExpenseEntry(expense, allGroups, allLedgers, backendUrl, headers);
            return;
        }

        const isRcmEligible =
            expense.rcm_eligible == 1 || expense.rcm_eligible === true || expense.rcm_eligible === '1' || expense.rcm_eligible === 'true' ||
            expense.vendor?.rcm_eligible == 1 || expense.vendor?.rcm_eligible === true || expense.vendor?.rcm_eligible === '1' || expense.vendor?.rcm_eligible === 'true';

        console.log(`🔍 RCM Eligibility Check:`, {
            isRcmEligible,
            expense_rcm: expense.rcm_eligible,
            vendor_rcm: expense.vendor?.rcm_eligible,
            vendor_name: expense.vendor?.name,
            tax_type: expense.tax_type
        });

        // Get the vendor's actual currency from the vendor object
        const vendor = expense.vendor;
        const vendorActualCurrency = vendor?.currency || "AED";

        // Determine if conversion is needed
        // ALWAYS record in AED in Webzash accounts
        let conversionRate = 1;
        let needsConversion = false;

        // If user entered amount in USD, convert to AED for accounting
        if (enteredCurrency === "USD") {
            const globalExchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.692);
            conversionRate = globalExchangeRate || process.env.REACT_APP_EXCHANGE_RATE_USD_AED; // Convert USD to AED (multiply by 3.67)
            needsConversion = true;
            console.log(`Converting USD to AED: User entered USD, converting to AED for accounts`);
        }
        // If user entered AED, no conversion needed (accounts already in AED)
        else if (enteredCurrency === "AED") {
            conversionRate = 1;
            needsConversion = false;
            console.log(`No conversion needed: User entered AED, accounts in AED`);
        }

        console.log(`Vendor Currency: ${vendorActualCurrency}`);
        console.log(`User Entered Currency: ${enteredCurrency}`);
        console.log(`Conversion Rate: ${conversionRate}, Needs Conversion: ${needsConversion}`);

        const expenseType = expense.expense_type;
        const adjustmentAmount = expense.adjustment_amount ? parseFloat(expense.adjustment_amount) : 0;

        const user = expense.user || (expense.user_id ? users.find((u) => String(u.id) === String(expense.user_id)) : null);

        if (!expenseType || (!vendor && !user)) {
            showToast("❌ Missing expense type or vendor/user.");
            return;
        }

        // ========== STEP 1: Ensure expense category group exists ==========
        const categoryName = expenseType.category?.name;
        const categoryGroupId = expenseType.category?.group_id;
        let expenseGroup = allGroups.find(g => g.Group?.name === categoryName)?.Group;

        if (!expenseGroup) {
            if (!categoryGroupId) {
                showToast("❌ Category is missing a group_id. Cannot create group.");
                return;
            }

            const parentGroup = allGroups.find(g => g.Group?.id === categoryGroupId)?.Group;
            if (!parentGroup) {
                showToast("❌ Parent group for this category not found.");
                return;
            }

            const groupPayload = {
                Group: {
                    name: categoryName,
                    parent_id: categoryGroupId,
                    affect_gross: 1,
                    code: null,
                }
            };

            const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
            const groupId = res.data?.id;

            if (!groupId) {
                showToast("❌ Failed to create group for this category.");
                return;
            }

            expenseGroup = { id: parseInt(groupId), name: categoryName };
        }

        // ========== CREATE ADJUSTMENT LEDGER IF ADJUSTMENT AMOUNT EXISTS ==========
        let adjustmentLedgerId = null;
        if (adjustmentAmount !== 0) {
            const adjustmentLedgerName = "Adjustment Charges";
            const existingAdjustmentLedger = allLedgers.find(l => l.Ledger?.name === adjustmentLedgerName);

            if (existingAdjustmentLedger) {
                adjustmentLedgerId = existingAdjustmentLedger.Ledger.id;
            } else {
                let bankFinGroup = allGroups.find(g => {
                    const normalized = g.Group?.name?.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
                    return normalized === "banking and financial charges";
                })?.Group;

                if (!bankFinGroup) {
                    const indirectGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                    if (!indirectGroup) {
                        showToast("❌ 'Indirect Expenses' group not found.");
                        return;
                    }

                    const createBankingGroup = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Banking and Financial Charges",
                            parent_id: indirectGroup.id,
                            affect_gross: 1,
                            code: null,
                        }
                    }, { headers });

                    const newGroupId = createBankingGroup.data?.id;
                    if (!newGroupId) {
                        showToast("❌ Failed to create 'Banking and Financial Charges' group.");
                        return;
                    }

                    const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = refresh.data;
                    bankFinGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
                }

                const adjustmentLedgerPayload = {
                    Ledger: {
                        name: adjustmentLedgerName,
                        group_id: bankFinGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Expense adjustment amount",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };

                const createLedger = await axios.post(`${backendUrl}/ledgers/add`, adjustmentLedgerPayload, { headers });
                adjustmentLedgerId = createLedger.data?.data?.Ledger?.id;
            }

            console.log(`Adjustment ledger created/found: ${adjustmentLedgerId}`);
        }


        // ========== STEP 2: Ensure expense ledger exists ==========
        const expenseLedgerName = expenseType.name;
        let debitLedger = allLedgers.find(l => l.Ledger?.name === expenseLedgerName);
        let debitLedgerId = null;

        if (debitLedger) {
            debitLedgerId = debitLedger.Ledger.id;
        } else {
            const ledgerPayload = {
                Ledger: {
                    name: expenseLedgerName,
                    group_id: expenseGroup.id,
                    op_balance: 0,
                    op_balance_dc: "D",
                    notes: "",
                    code: null,
                    type: 0,
                    reconciliation: 0,
                }
            };

            try {
                const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                debitLedgerId = res.data?.data?.Ledger?.id;
            } catch (err) {
                const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                const existing = refresh.data?.data?.find(l => l.Ledger?.name === expenseLedgerName);
                debitLedgerId = existing?.Ledger?.id;

                if (!debitLedgerId) {
                    showToast("❌ Expense ledger exists but ID not found.");
                    return;
                }
            }
        }

        // ========== STEP 3: Determine credit ledger ==========
        let creditLedgerId = null;
        let creditLedgerName = "";
        let creditLedgerGroupName = "";
        const isEmployeePaid = Boolean(vendor && user);


        // if (vendor && user) {
        //     creditLedgerName = user.name;
        //     creditLedgerGroupName = "Loans (Liabilities)";
        // } else 
        if (isEmployeePaid) {
            // Employee paid on behalf of company
            creditLedgerName = user.name;
            creditLedgerGroupName = "Loans (Liabilities)";
        } else if (vendor) {
            creditLedgerName = vendor.name;
            creditLedgerGroupName = "Sundry Creditors (Vendors)";
        } else if (user) {
            creditLedgerName = user.name;
            creditLedgerGroupName = "Loans (Liabilities)";
        }

        // ========== STEP 4: Find or create credit ledger ==========
        let creditGroup = allGroups.find(g => g.Group?.name === creditLedgerGroupName)?.Group;

        if (!creditGroup) {
            const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;

            if (!parentLiabilitiesGroup) {
                showToast("'Liabilities and Owners Equity' group not found.");
                return;
            }

            const groupPayload = {
                Group: {
                    name: creditLedgerGroupName,
                    parent_id: parentLiabilitiesGroup.id,
                    affect_gross: 0,
                    code: null
                }
            };

            const groupRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
            const newGroupId = groupRes.data?.id;

            if (!newGroupId) {
                showToast(`Failed to create group '${creditLedgerGroupName}'.`);
                return;
            }

            const groupRes2 = await axios.get(`${backendUrl}/groups/index`, { headers });
            allGroups = groupRes2.data;
            creditGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
        }

        let creditLedger = allLedgers.find(l => l.Ledger?.name === creditLedgerName);
        if (creditLedger) {
            creditLedgerId = creditLedger.Ledger.id;
        } else {
            const creditLedgerPayload = {
                Ledger: {
                    name: creditLedgerName,
                    group_id: creditGroup.id,
                    op_balance: 0,
                    op_balance_dc: "C",
                    notes: "",
                    code: null,
                    type: 0,
                    reconciliation: 0,
                }
            };

            try {
                const res = await axios.post(`${backendUrl}/ledgers/add`, creditLedgerPayload, { headers });
                creditLedgerId = res.data?.data?.Ledger?.id;
            } catch (err) {
                const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                const existing = refresh.data?.data?.find(l => l.Ledger?.name === creditLedgerName);
                creditLedgerId = existing?.Ledger?.id;

                if (!creditLedgerId) {
                    showToast(`Ledger '${creditLedgerName}' exists but ID not found.`);
                    return;
                }
            }
        }

        // ========== STEP 5: Handle vendor-specific cases ==========
        let vendorLedgerId = null;
        if (vendor && user) {
            const vendorLedgerName = vendor.name;
            const vendorGroupName = "Sundry Creditors (Vendors)";

            let vendorGroup = allGroups.find(g => g.Group?.name === vendorGroupName)?.Group;
            if (!vendorGroup) {
                const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
                const vendorGroupPayload = {
                    Group: {
                        name: vendorGroupName,
                        parent_id: parentLiabilitiesGroup.id,
                        affect_gross: 0,
                        code: null,
                    }
                };
                const groupRes = await axios.post(`${backendUrl}/groups/add`, vendorGroupPayload, { headers });
                const newGroupId = groupRes.data?.id;
                const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
                allGroups = refresh.data;
                vendorGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
            }

            let vendorLedger = allLedgers.find(l => l.Ledger?.name === vendorLedgerName);
            if (!vendorLedger) {
                const vendorLedgerPayload = {
                    Ledger: {
                        name: vendorLedgerName,
                        group_id: vendorGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C",
                        notes: "",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };
                const res = await axios.post(`${backendUrl}/ledgers/add`, vendorLedgerPayload, { headers });
                vendorLedgerId = res.data?.data?.Ledger?.id;
            } else {
                vendorLedgerId = vendorLedger.Ledger.id;
            }
        }

        // ========== STEP 6: Calculate amounts with currency conversion ==========
        // let expenseAmount = 0;
        // let vatAmount = 0;
        // let convertedAdjustmentAmount = 0;

        // if (expense.tax_type === 'taxable') {
        //     const baseAmount = parseFloat(expense.amount_without_tax || 0);

        //     // Apply conversion if user entered USD
        //     if (needsConversion) {
        //         expenseAmount = parseFloat((baseAmount * conversionRate).toFixed(2));
        //         console.log(`Taxable: Converted ${baseAmount} USD to ${expenseAmount} AED for accounting`);
        //     } else {
        //         expenseAmount = baseAmount;
        //         console.log(`Taxable: Using ${expenseAmount} AED (no conversion needed)`);
        //     }

        //     vatAmount = parseFloat((expenseAmount * 0.05).toFixed(2));

        //     // Convert adjustment amount if user entered USD
        //     if (adjustmentAmount > 0) {
        //         if (needsConversion) {
        //             convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdjustmentAmount = adjustmentAmount;
        //         }
        //     }
        // } else {
        //     const baseAmount = parseFloat(expense.amount || 0);

        //     // Apply conversion if user entered USD
        //     if (needsConversion) {
        //         expenseAmount = parseFloat((baseAmount * conversionRate).toFixed(2));
        //         console.log(`Non-taxable: Converted ${baseAmount} USD to ${expenseAmount} AED for accounting`);
        //     } else {
        //         expenseAmount = baseAmount;
        //         console.log(`Non-taxable: Using ${expenseAmount} AED (no conversion needed)`);
        //     }

        //     vatAmount = 0;

        //     // Convert adjustment amount if user entered USD
        //     if (adjustmentAmount > 0) {
        //         if (needsConversion) {
        //             convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdjustmentAmount = adjustmentAmount;
        //         }
        //     }
        // }
        // ========== STEP 6: Calculate amounts with currency conversion ==========
        // ========== STEP 6: Calculate amounts with currency conversion ==========
        // ========== STEP 6: Calculate amounts with currency conversion ==========
        // let fullExpenseAmount = 0;  // Rename for clarity
        // let vatAmount = 0;
        // let convertedAdjustmentAmount = 0;
        // let convertedAdvanceApplied = 0;

        // // First, check if we're using advance
        // const advanceApplied = parseFloat(expense.advance_applied || 0);
        // const isUsingAdvance = (expense.apply_advance == 1 || expense.apply_advance === true) && advanceApplied > 0;

        // console.log(`Advance Check: apply_advance=${expense.apply_advance}, advanceApplied=${advanceApplied}, isUsingAdvance=${isUsingAdvance}`);

        // if (expense.tax_type === 'taxable') {
        //     // Get the NET amount from form (already reduced by advance)
        //     const netBaseAmount = parseFloat(expense.amount_without_tax || 0);

        //     // Calculate ORIGINAL/FULL amount by adding back the advance
        //     const originalBaseAmount = netBaseAmount + (isUsingAdvance ? advanceApplied : 0);

        //     // Apply conversion if needed (on ORIGINAL amount)
        //     if (needsConversion) {
        //         fullExpenseAmount = parseFloat((originalBaseAmount * conversionRate).toFixed(2));
        //         console.log(`Taxable: Original ${originalBaseAmount} ${enteredCurrency} = ${fullExpenseAmount} AED`);
        //     } else {
        //         fullExpenseAmount = originalBaseAmount;
        //         console.log(`Taxable: Using ${fullExpenseAmount} AED (no conversion needed)`);
        //     }

        //     // Calculate VAT on NET amount (after advance)
        //     const netAmountInAED = needsConversion ? 
        //         parseFloat((netBaseAmount * conversionRate).toFixed(2)) : netBaseAmount;
        //     // vatAmount = parseFloat((netAmountInAED * 0.05).toFixed(2));
        //         vatAmount = parseFloat((fullExpenseAmount * 0.05).toFixed(2));


        //     // Convert adjustment amount
        //     if (adjustmentAmount > 0) {
        //         if (needsConversion) {
        //             convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdjustmentAmount = adjustmentAmount;
        //         }
        //     }

        //     // Convert advance amount if applicable
        //     if (isUsingAdvance) {
        //         if (needsConversion) {
        //             convertedAdvanceApplied = parseFloat((advanceApplied * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdvanceApplied = advanceApplied;
        //         }
        //     }
        // } else {
        //     // For non-taxable
        //     const netAmount = parseFloat(expense.amount || 0);
        //     const originalAmount = netAmount + (isUsingAdvance ? advanceApplied : 0);

        //     // Apply conversion if needed
        //     if (needsConversion) {
        //         fullExpenseAmount = parseFloat((originalAmount * conversionRate).toFixed(2));
        //         console.log(`Non-taxable: Original ${originalAmount} ${enteredCurrency} = ${fullExpenseAmount} AED`);
        //     } else {
        //         fullExpenseAmount = originalAmount;
        //         console.log(`Non-taxable: Using ${fullExpenseAmount} AED (no conversion needed)`);
        //     }

        //     vatAmount = 0;

        //     // Convert adjustment amount
        //     if (adjustmentAmount > 0) {
        //         if (needsConversion) {
        //             convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdjustmentAmount = adjustmentAmount;
        //         }
        //     }

        //     // Convert advance amount if applicable
        //     if (isUsingAdvance) {
        //         if (needsConversion) {
        //             convertedAdvanceApplied = parseFloat((advanceApplied * conversionRate).toFixed(2));
        //         } else {
        //             convertedAdvanceApplied = advanceApplied;
        //         }
        //     }
        // }
        // ========== STEP 6: Calculate amounts with currency conversion ==========
        let fullExpenseAmount = 0;
        let vatAmount = 0;
        let convertedAdjustmentAmount = 0;
        let convertedAdvanceApplied = 0;

        // First, check if we're using advance
        const advanceApplied = parseFloat(expense.advance_applied || 0);
        const isUsingAdvance = (expense.apply_advance == 1 || expense.apply_advance === true) && advanceApplied > 0;

        console.log(`Advance Check: apply_advance=${expense.apply_advance}, advanceApplied=${advanceApplied}, isUsingAdvance=${isUsingAdvance}`);

        if (expense.tax_type === 'taxable') {
            // ✅ amount_without_tax already contains the FULL ORIGINAL invoice amount
            const originalBaseAmount = parseFloat(expense.amount_without_tax || 0);

            // Apply conversion if needed (on ORIGINAL amount)
            if (needsConversion) {
                fullExpenseAmount = parseFloat((originalBaseAmount * conversionRate).toFixed(2));
                console.log(`Taxable: Original ${originalBaseAmount} ${enteredCurrency} = ${fullExpenseAmount} AED`);
            } else {
                fullExpenseAmount = originalBaseAmount;
                console.log(`Taxable: Using ${fullExpenseAmount} AED (no conversion needed)`);
            }

            // ✅ Use saved vat_amount if available, otherwise calculate using tax rate
            const rawVat = expense.vat_amount;
            if (rawVat !== null && rawVat !== undefined && rawVat !== '') {
                vatAmount = parseFloat((parseFloat(rawVat) * conversionRate).toFixed(2));
                console.log(`Using saved VAT amount: ${rawVat} ${enteredCurrency} = ${vatAmount} AED`);
            } else {
                const taxRate = parseFloat(expense.tax || 5) / 100;
                vatAmount = parseFloat((fullExpenseAmount * taxRate).toFixed(2));
                console.log(`VAT calculated on ${fullExpenseAmount} AED using ${taxRate * 100}% = ${vatAmount} AED`);
            }

            // Convert adjustment amount
            if (adjustmentAmount !== 0) {
                if (needsConversion) {
                    convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
                } else {
                    convertedAdjustmentAmount = adjustmentAmount;
                }
            }

            // Convert advance amount if applicable
            if (isUsingAdvance) {
                if (needsConversion) {
                    convertedAdvanceApplied = parseFloat((advanceApplied * conversionRate).toFixed(2));
                } else {
                    convertedAdvanceApplied = advanceApplied;
                }
                console.log(`Advance: ${advanceApplied} ${enteredCurrency} = ${convertedAdvanceApplied} AED`);
            }
        } else {
            // For non-taxable
            // ✅ amount field already contains the FULL amount (if advance was applied, it's net amount)
            // We need to add back the advance to get the original amount
            const netAmount = parseFloat(expense.amount || 0);
            const originalAmount = isUsingAdvance ? (netAmount + advanceApplied) : netAmount;

            // Apply conversion if needed
            if (needsConversion) {
                fullExpenseAmount = parseFloat((originalAmount * conversionRate).toFixed(2));
                console.log(`Non-taxable: Original ${originalAmount} ${enteredCurrency} = ${fullExpenseAmount} AED`);
            } else {
                fullExpenseAmount = originalAmount;
                console.log(`Non-taxable: Using ${fullExpenseAmount} AED (no conversion needed)`);
            }

            // For RCM, use saved vat_amount if available
            const rawVat = expense.vat_amount;
            if (isRcmEligible) {
                if (rawVat !== null && rawVat !== undefined && rawVat !== '') {
                    vatAmount = parseFloat((parseFloat(rawVat) * conversionRate).toFixed(2));
                } else {
                    vatAmount = parseFloat((fullExpenseAmount * 0.05).toFixed(2));
                }
            } else {
                vatAmount = 0;
            }
            console.log(`Non-taxable RCM VAT (if applicable) = ${vatAmount} AED`);

            // Convert adjustment amount
            if (adjustmentAmount !== 0) {
                if (needsConversion) {
                    convertedAdjustmentAmount = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
                } else {
                    convertedAdjustmentAmount = adjustmentAmount;
                }
            }

            // Convert advance amount if applicable
            if (isUsingAdvance) {
                if (needsConversion) {
                    convertedAdvanceApplied = parseFloat((advanceApplied * conversionRate).toFixed(2));
                } else {
                    convertedAdvanceApplied = advanceApplied;
                }
                console.log(`Advance: ${advanceApplied} ${enteredCurrency} = ${convertedAdvanceApplied} AED`);
            }
        }

        console.log(`Final amounts - 
  FULL Expense: ${fullExpenseAmount} AED, 
  VAT: ${vatAmount} AED, 
  Advance: ${convertedAdvanceApplied} AED, 
  Adjustment: ${convertedAdjustmentAmount} AED,
  Total Credit: ${fullExpenseAmount + vatAmount + convertedAdjustmentAmount} AED`);

        console.log(`Final amounts - FULL Expense: ${fullExpenseAmount}, NET Expense: ${fullExpenseAmount - convertedAdvanceApplied}, VAT: ${vatAmount}, Advance: ${convertedAdvanceApplied}, Adjustment: ${convertedAdjustmentAmount}`);
        // ========== STEP 7: Handle VAT ledger ==========
        let inputVATLedgerId = null;
        if (vatAmount > 0) {
            let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;

            if (!taxAssetGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                const groupPayload = {
                    Group: {
                        name: "Tax Assets",
                        parent_id: parentAssetsGroup.id,
                        affect_gross: 0,
                        code: null
                    }
                };
                const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
                taxAssetGroup = { id: parseInt(res.data?.id), name: "Tax Assets" };
            }

            const inputVATLedgerName = "Input VAT";
            let inputVATLedger = allLedgers.find(l => l.Ledger?.name === inputVATLedgerName);
            if (!inputVATLedger) {
                const vatLedgerPayload = {
                    Ledger: {
                        name: inputVATLedgerName,
                        group_id: taxAssetGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };
                const res = await axios.post(`${backendUrl}/ledgers/add`, vatLedgerPayload, { headers });
                inputVATLedgerId = res.data?.data?.Ledger?.id;
            } else {
                inputVATLedgerId = inputVATLedger.Ledger.id;
            }
        }

        // ========== STEP 7.2: Handle RCM VAT ledgers ==========
        let rcmInputVATLedgerId = null;
        let rcmOutputVATLedgerId = null;

        if (vatAmount > 0 && isRcmEligible) {
            // 1. RCM Input VAT Ledger (Asset)
            const rcmInputVATLedgerName = "Input VAT � RCM";
            let rcmInputLedger = allLedgers.find(l => l.Ledger?.name === rcmInputVATLedgerName);

            if (!rcmInputLedger) {
                let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;
                if (!taxAssetGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name: "Tax Assets", parent_id: parentAssetsGroup.id, affect_gross: 0, code: null }
                    }, { headers });
                    taxAssetGroup = { id: parseInt(res.data?.id), name: "Tax Assets" };
                }

                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: rcmInputVATLedgerName,
                        group_id: taxAssetGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Reverse Charge Mechanism Input VAT",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                }, { headers });
                rcmInputVATLedgerId = res.data?.data?.Ledger?.id;
            } else {
                rcmInputVATLedgerId = rcmInputLedger.Ledger.id;
            }

            // 2. RCM Output VAT Ledger (Liability)
            const rcmOutputVATLedgerName = "Output VAT � RCM";
            let rcmOutputLedger = allLedgers.find(l => l.Ledger?.name === rcmOutputVATLedgerName);

            if (!rcmOutputLedger) {
                let taxLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Duties and Taxes")?.Group;
                if (!taxLiabilitiesGroup) {
                    const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name: "Duties and Taxes", parent_id: parentLiabilitiesGroup.id, affect_gross: 0, code: null }
                    }, { headers });
                    taxLiabilitiesGroup = { id: parseInt(res.data?.id), name: "Duties and Taxes" };
                }

                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: rcmOutputVATLedgerName,
                        group_id: taxLiabilitiesGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C",
                        notes: "Reverse Charge Mechanism Output VAT",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                }, { headers });
                rcmOutputVATLedgerId = res.data?.data?.Ledger?.id;
            } else {
                rcmOutputVATLedgerId = rcmOutputLedger.Ledger.id;
            }
        }
        // ========== STEP 7.5: Create Vendor Advance Ledger if advance is being used ==========
        // ========== STEP 7.5: Create Vendor Advance Group and Ledger if advance is being used ==========
        let vendorAdvanceLedgerId = null;
        // const advanceApplied = parseFloat(expense.advance_applied || 0);
        // const isUsingAdvance = expense.apply_advance && advanceApplied > 0;

        if (isUsingAdvance) {
            const vendorAdvanceGroupName = "Vendor Advance";
            const vendorAdvanceLedgerName = "Vendor Advances"; // Could be same name or different

            // First, find or create Vendor Advances group under Current Assets
            let currentAssetsGroup = allGroups.find(g =>
                g.Group?.name === "Current Assets" || g.name === "Current Assets"
            )?.Group;

            if (!currentAssetsGroup) {
                showToast("❌ 'Current Assets' group not found. Cannot create Vendor Advances ledger.");
                return;
            }

            // Look for Vendor Advances group under Current Assets
            let vendorAdvanceGroup = allGroups.find(g => {
                const groupName = g.Group?.name || g.name;
                const parentId = g.Group?.parent_id || g.parent_id;
                return groupName === vendorAdvanceGroupName && parentId === currentAssetsGroup.id;
            })?.Group;

            let vendorAdvanceGroupId = null;

            // Create Vendor Advances group if it doesn't exist
            if (!vendorAdvanceGroup) {
                try {
                    const groupPayload = {
                        Group: {
                            name: vendorAdvanceGroupName,
                            parent_id: currentAssetsGroup.id,
                            affect_gross: 0,
                            code: null,
                        }
                    };

                    const groupRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
                    vendorAdvanceGroupId = groupRes.data?.id;

                    if (!vendorAdvanceGroupId) {
                        showToast("❌ Failed to create Vendor Advances group.");
                        return;
                    }

                    console.log(`✅ Created Vendor Advances group: ${vendorAdvanceGroupId}`);

                    // Refresh groups list to include the new group
                    const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = refresh.data;

                    // Find the newly created group
                    vendorAdvanceGroup = allGroups.find(g => g.Group?.id == vendorAdvanceGroupId)?.Group;

                } catch (error) {
                    console.error("Error creating Vendor Advances group:", error);
                    showToast("❌ Failed to create Vendor Advances group.");
                    return;
                }
            } else {
                vendorAdvanceGroupId = vendorAdvanceGroup.id;
                console.log(`✅ Found existing Vendor Advances group: ${vendorAdvanceGroupId}`);
            }

            // Now find or create Vendor Advances ledger under the Vendor Advances group
            let vendorAdvanceLedger = allLedgers.find(l =>
                l.Ledger?.name === vendorAdvanceLedgerName &&
                l.Ledger?.group_id === vendorAdvanceGroupId
            );

            if (!vendorAdvanceLedger) {
                const vendorAdvancePayload = {
                    Ledger: {
                        name: vendorAdvanceLedgerName,
                        group_id: vendorAdvanceGroupId,
                        op_balance: 0,
                        op_balance_dc: "D", // Debit balance for asset account
                        notes: "Advances given to vendors",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };

                try {
                    const res = await axios.post(`${backendUrl}/ledgers/add`, vendorAdvancePayload, { headers });
                    vendorAdvanceLedgerId = res.data?.data?.Ledger?.id;
                    console.log(`✅ Created Vendor Advances ledger: ${vendorAdvanceLedgerId}`);

                    // Refresh ledgers list
                    const ledgerRefresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    allLedgers = ledgerRefresh.data?.data;

                } catch (error) {
                    console.error("Error creating Vendor Advances ledger:", error);
                    showToast("❌ Failed to create Vendor Advances ledger.");
                    return;
                }
            } else {
                vendorAdvanceLedgerId = vendorAdvanceLedger.Ledger.id;
                console.log(`✅ Found existing Vendor Advances ledger: ${vendorAdvanceLedgerId}`);
            }
        }

        // ========== STEP 8: Build entry items ==========
        //         const entryItems = [];
        //         let ExpenseDebitID = expenseType.is_deferred ? deferredLedgerId : debitLedgerId;
        //         const totalCreditAmount = expenseAmount + vatAmount + convertedAdjustmentAmount;


        //         // 1. Debit expense ledger
        //         entryItems.push({
        //             dc: "D",
        //             ledger_id: ExpenseDebitID,
        //             dr_amount: expenseAmount.toFixed(2),
        //             cr_amount: null
        //         });

        //         // 2. Debit VAT if applicable
        //         if (vatAmount > 0) {
        //             entryItems.push({
        //                 dc: "D",
        //                 ledger_id: inputVATLedgerId,
        //                 dr_amount: vatAmount.toFixed(2),
        //                 cr_amount: null
        //             });
        //         }

        //         // 3. Debit adjustment amount if applicable
        //         // if (convertedAdjustmentAmount > 0 && adjustmentLedgerId) {
        //         //     entryItems.push({
        //         //         dc: "D",
        //         //         ledger_id: adjustmentLedgerId,
        //         //         dr_amount: convertedAdjustmentAmount.toFixed(2),
        //         //         cr_amount: null
        //         //     });
        //         // }
        //         if (convertedAdjustmentAmount > 0) {
        //             if (!adjustmentLedgerId) {
        //                 showToast("⚠ Adjustment ledger missing — creating automatically");
        //                 // force create "Adjustment Charges" ledger
        //             }

        //             entryItems.push({
        //                 dc: "D",
        //                 ledger_id: adjustmentLedgerId,
        //                 dr_amount: convertedAdjustmentAmount.toFixed(2),
        //                 cr_amount: null
        //             });
        //         }
        //         // if (isUsingAdvance && vendorAdvanceLedgerId) {
        //         //     // === CASE A: USING VENDOR ADVANCE ===
        //         //     // 4a. CREDIT Vendor Advance (asset decreases)
        //         //     console.log(`💰 Applying vendor advance: ${advanceApplied} from total: ${totalCreditAmount}`);

        //         //     entryItems.push({
        //         //         dc: "C",
        //         //         ledger_id: vendorAdvanceLedgerId,
        //         //         dr_amount: null,
        //         //         cr_amount: advanceApplied.toFixed(2)
        //         //     });

        //         //     // 4b. CREDIT Vendor for remaining amount
        //         //     const remainingToPay = totalCreditAmount - advanceApplied;
        //         //     if (remainingToPay > 0) {
        //         //         entryItems.push({
        //         //             dc: "C",
        //         //             ledger_id: creditLedgerId,
        //         //             dr_amount: null,
        //         //             cr_amount: remainingToPay.toFixed(2)
        //         //         });
        //         //     }

        //         //     console.log(`💰 Advance Applied: ${advanceApplied}, Remaining to Vendor: ${remainingToPay}`);
        //         // } else {
        //         //     // === CASE B: NO ADVANCE - Full credit to vendor ===
        //         //     entryItems.push({
        //         //         dc: "C",
        //         //         ledger_id: creditLedgerId,
        //         //         dr_amount: null,
        //         //         cr_amount: totalCreditAmount.toFixed(2)
        //         //     });
        //         // }
        //  if (isUsingAdvance && vendorAdvanceLedgerId) {
        //     // === USING VENDOR ADVANCE ===
        //     // Vendor Advances is an Asset account
        //     // Asset accounts: Debit increases, Credit decreases
        //     // When using advance, we need to DECREASE the asset (Credit)

        //     console.log(`💰 Applying vendor advance: ${convertedAdvanceApplied} AED from total: ${totalCreditAmount} AED`);

        //     // CREDIT Vendor Advance to reduce the asset balance
        //     entryItems.push({
        //         dc: "C",  // Credit to reduce an asset
        //         ledger_id: vendorAdvanceLedgerId,
        //         dr_amount: null,
        //         cr_amount: convertedAdvanceApplied.toFixed(2)
        //     });

        //     // CREDIT Vendor for remaining amount (if any)
        //     const remainingToPay = totalCreditAmount - convertedAdvanceApplied;
        //     if (remainingToPay > 0) {
        //         entryItems.push({
        //             dc: "C",
        //             ledger_id: creditLedgerId,
        //             dr_amount: null,
        //             cr_amount: remainingToPay.toFixed(2)
        //         });
        //     }

        //     console.log(`💰 Advance Applied: ${convertedAdvanceApplied} AED, Remaining to Vendor: ${remainingToPay} AED`);
        // } else {
        //     // === NO ADVANCE - Full credit to vendor ===
        //     entryItems.push({
        //         dc: "C",
        //         ledger_id: creditLedgerId,
        //         dr_amount: null,
        //         cr_amount: totalCreditAmount.toFixed(2)
        //     });
        // }
        // ========== STEP 8: Build entry items ==========
        const entryItems = [];
        let ExpenseDebitID = debitLedgerId;
        // Adjust total credit amount for vendor: For RCM, VAT is NOT included in vendor credit
        const totalCreditAmount = isRcmEligible
            ? (fullExpenseAmount + convertedAdjustmentAmount)
            : (fullExpenseAmount + vatAmount + convertedAdjustmentAmount);

        // 1. Debit expense ledger (FULL amount)
        entryItems.push({
            dc: "D",
            ledger_id: ExpenseDebitID,
            dr_amount: fullExpenseAmount.toFixed(2),
            cr_amount: null
        });

        // 2. Debit VAT if applicable (calculated on NET amount)
        if (vatAmount > 0) {
            if (isRcmEligible) {
                // RCM Case: Debit RCM Input VAT and Credit RCM Output VAT
                // The vendor is NOT paid the VAT.
                entryItems.push({
                    dc: "D",
                    ledger_id: rcmInputVATLedgerId,
                    dr_amount: vatAmount.toFixed(2),
                    cr_amount: null
                });
                entryItems.push({
                    dc: "C",
                    ledger_id: rcmOutputVATLedgerId,
                    dr_amount: null,
                    cr_amount: vatAmount.toFixed(2)
                });
            } else {
                // Normal Case: Debit normal Input VAT
                entryItems.push({
                    dc: "D",
                    ledger_id: inputVATLedgerId,
                    dr_amount: vatAmount.toFixed(2),
                    cr_amount: null
                });
            }
        }

        // 3. Handle adjustment amount if applicable
        if (convertedAdjustmentAmount !== 0) {
            const isNegative = convertedAdjustmentAmount < 0;
            entryItems.push({
                dc: isNegative ? "C" : "D",
                ledger_id: adjustmentLedgerId,
                dr_amount: isNegative ? null : Math.abs(convertedAdjustmentAmount).toFixed(2),
                cr_amount: isNegative ? Math.abs(convertedAdjustmentAmount).toFixed(2) : null
            });
        }

        // 4. Handle advance case for regular transactions
        if (!vendor || !user) {
            if (isUsingAdvance && vendorAdvanceLedgerId) {
                console.log(`💰 Using vendor advance: ${convertedAdvanceApplied} AED from total: ${totalCreditAmount} AED`);

                // 1. Credit Vendor for FULL amount
                entryItems.push({
                    dc: "C",
                    ledger_id: creditLedgerId,
                    dr_amount: null,
                    cr_amount: totalCreditAmount.toFixed(2)
                });

                // 2. Reduce vendor payable by applying advance
                entryItems.push({
                    dc: "D",
                    ledger_id: creditLedgerId,
                    dr_amount: convertedAdvanceApplied.toFixed(2),
                    cr_amount: null
                });

                // 3. Reduce vendor advance (asset) by crediting it
                entryItems.push({
                    dc: "C",
                    ledger_id: vendorAdvanceLedgerId,
                    dr_amount: null,
                    cr_amount: convertedAdvanceApplied.toFixed(2)
                });

                console.log(`💰 Full Expense: ${totalCreditAmount} AED, Advance Applied: ${convertedAdvanceApplied} AED`);
            } else {
                // No advance - Full credit to vendor
                entryItems.push({
                    dc: "C",
                    ledger_id: creditLedgerId,
                    dr_amount: null,
                    cr_amount: totalCreditAmount.toFixed(2)
                });
            }
        }


        // 4. Handle vendor/user combinations

        // if (vendor && user) {
        //     // Vendor-to-User transaction
        //     entryItems.push({
        //         dc: "C",
        //         ledger_id: vendorLedgerId,
        //         dr_amount: null,
        //         cr_amount: totalCreditAmount.toFixed(2)
        //     });

        //     entryItems.push({
        //         dc: "D",
        //         ledger_id: vendorLedgerId,
        //         dr_amount: totalCreditAmount.toFixed(2),
        //         cr_amount: null
        //     });

        //     entryItems.push({
        //         dc: "C",
        //         ledger_id: creditLedgerId,
        //         dr_amount: null,
        //         cr_amount: totalCreditAmount.toFixed(2)
        //     });

        // } else {
        //     // Regular case - single credit entry
        //     entryItems.push({
        //         dc: "C",
        //         ledger_id: creditLedgerId,
        //         dr_amount: null,
        //         cr_amount: totalCreditAmount.toFixed(2)
        //     });
        // }
        if (vendor && user) {
            // Employee paid the vendor. We credit the Employee (User) and Debit Expense.
            // Vendor ledger is NOT hit as requested.

            if (isUsingAdvance && vendorAdvanceLedgerId) {
                // If some portion was paid via vendor advance
                console.log(`?? Vendor/User Advance: ${convertedAdvanceApplied} AED from total: ${totalCreditAmount} AED`);

                entryItems.push({
                    dc: "C",
                    ledger_id: vendorAdvanceLedgerId,
                    dr_amount: null,
                    cr_amount: convertedAdvanceApplied.toFixed(2)
                });

                const remainingToPay = totalCreditAmount - convertedAdvanceApplied;
                if (remainingToPay > 0) {
                    entryItems.push({
                        dc: "C",
                        ledger_id: creditLedgerId,
                        dr_amount: null,
                        cr_amount: remainingToPay.toFixed(2)
                    });
                }
            } else {
                // Full amount paid by employee
                entryItems.push({
                    dc: "C",
                    ledger_id: creditLedgerId,
                    dr_amount: null,
                    cr_amount: totalCreditAmount.toFixed(2)
                });
            }
        }

        if (!creditLedgerId) {
            showToast("❌ Credit ledger not found. Cannot proceed.");
            return;
        }

        // ========== STEP 9: Create final payload ==========
        // Add currency info to narration
        const narrationWithCurrency = `Expense: ${expenseType.name} by ${vendor ? vendor.name : user?.name ?? ''}`;
        const fullNarration = expense.narration || `${narrationWithCurrency} (Vendor: ${vendorActualCurrency}, Entered: ${enteredCurrency}${needsConversion ? ', Converted to AED' : ''})`;

        const entryPayload = {
            Entry: {
                tag_id: null,
                number: generateUniqueEntryNumber(),
                date: expense.date,
                narration: fullNarration,
                client_id: parseInt(expense?.client_id) || parseInt(expense?.project?.client_id) || null,
                user_id: parseInt(user?.id || expense?.user_id) || null,
                project_id: parseInt(expense?.project_id) || null,
                is_import: true,
            },
            Entryitem: entryItems
        };

        // ========== STEP 10: Submit entry ==========
        try {
            const res = await axios.post(`${backendUrl}/entries/add/journal`, entryPayload, { headers });
            if (res.data?.status === 'error') {
                showToast(`❌ ${res.data.message || 'Failed to create Expense.'}`);
                return;
            }
            const webzashEntryId = res.data.entry_id;

            const backend = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.post(
                `${backend}/api/expense/${expense.id}/journal`,
                {
                    journal_id: webzashEntryId,
                    // Save currency info for reference
                    currency_info: JSON.stringify({
                        vendor_currency: vendorActualCurrency,
                        entered_currency: enteredCurrency,
                        conversion_rate: needsConversion ? conversionRate : 1,
                        was_converted: needsConversion,
                        accounting_currency: "AED"
                    })
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                }
            );
        } catch (err) {
            showToast("❌ Failed to create Expense.");
            console.error(err);
        }
    };
    // const createSalaryExpenseEntry = async (expense, allGroups, allLedgers, backendUrl, headers) => {
    //     try {
    //         // Get the entered currency (salary expenses should be in AED but handle USD if entered)
    //         const enteredCurrency = expense.vendor_currency || "AED";

    //         // Determine if conversion is needed
    //         let conversionRate = 1;
    //         let needsConversion = false;

    //         if (enteredCurrency === "USD") {
    //             const globalExchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.692);
    //             conversionRate = globalExchangeRate || process.env.REACT_APP_EXCHANGE_RATE_USD_AED;
    //             needsConversion = true;
    //         }

    //         const expenseType = expense.expense_type;
    //         const amount = parseFloat(expense.amount) || 0;
    //         const originalAmount = amount; // Store original amount for reference
    //         // Parse WPS fields
    //         const wpsCharge = parseFloat(expense.wps_charge) || 0;
    //         const wpsVat = parseFloat(expense.wps_vat) || 0;


    //         if (!expenseType || amount <= 0) {
    //             showToast("❌ Missing expense type or invalid amount for salary expense.");
    //             return;
    //         }

    //         let finalAmount = parseFloat((amount * conversionRate).toFixed(2));

    //         // ========== STEP 1: Ensure Salary Payable ledger exists ==========
    //         const salaryPayableLedgerName = "Salary Payable";
    //         let salaryPayableLedger = allLedgers.find(l => l.Ledger?.name === salaryPayableLedgerName);
    //         let salaryPayableLedgerId = null;

    //         if (salaryPayableLedger) {
    //             salaryPayableLedgerId = salaryPayableLedger.Ledger.id;
    //         } else {
    //             // Find or create Current Liabilities group
    //             const currentLiabilitiesGroupName = "Current Liabilities";
    //             let currentLiabilitiesGroup = allGroups.find(g =>
    //                 g.Group?.name === currentLiabilitiesGroupName
    //             )?.Group;

    //             // If Current Liabilities group doesn't exist, find Liabilities parent
    //             if (!currentLiabilitiesGroup) {
    //                 const liabilitiesGroup = allGroups.find(g =>
    //                     g.Group?.name === "Liabilities and Owners Equity"
    //                 )?.Group;

    //                 if (!liabilitiesGroup) {
    //                     showToast("❌ 'Liabilities and Owners Equity' group not found.");
    //                     return;
    //                 }

    //                 // Create Current Liabilities group
    //                 const groupPayload = {
    //                     Group: {
    //                         name: currentLiabilitiesGroupName,
    //                         parent_id: liabilitiesGroup.id,
    //                         affect_gross: 0,
    //                         code: null,
    //                     }
    //                 };

    //                 const groupRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //                 const newGroupId = groupRes.data?.id;

    //                 if (!newGroupId) {
    //                     showToast("❌ Failed to create Current Liabilities group.");
    //                     return;
    //                 }


    //                 // Refresh groups
    //                 const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
    //                 allGroups = refresh.data;
    //                 currentLiabilitiesGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
    //             }

    //             // Create Salary Payable ledger under Current Liabilities
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: salaryPayableLedgerName,
    //                     group_id: currentLiabilitiesGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "C", // Credit balance for liability
    //                     notes: "Accrued salary payable to employees",
    //                     code: null,
    //                     type: 0,
    //                     reconciliation: 0,
    //                 }
    //             };

    //             try {
    //                 const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                 salaryPayableLedgerId = res.data?.data?.Ledger?.id;

    //                 // Refresh ledgers
    //                 const ledgerRefresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //                 allLedgers = ledgerRefresh.data?.data;
    //             } catch (err) {
    //                 console.error("Error creating Salary Payable ledger:", err);
    //                 showToast("❌ Failed to create Salary Payable ledger.");
    //                 return;
    //             }
    //         }

    //         // ========== STEP 2: Ensure expense category group and ledger exist ==========
    //         const categoryName = expenseType.category?.name;
    //         const categoryGroupId = expenseType.category?.group_id;
    //         let expenseGroup = allGroups.find(g => g.Group?.name === categoryName)?.Group;

    //         if (!expenseGroup) {
    //             if (!categoryGroupId) {
    //                 showToast("❌ Category is missing a group_id. Cannot create group.");
    //                 return;
    //             }

    //             const parentGroup = allGroups.find(g => g.Group?.id === categoryGroupId)?.Group;
    //             if (!parentGroup) {
    //                 // Try to find parent by ID directly first
    //                 // If fail, maybe try to find by name if we knew it, but here rely on ID
    //             }

    //             const groupPayload = {
    //                 Group: {
    //                     name: categoryName,
    //                     parent_id: categoryGroupId,
    //                     affect_gross: 1,
    //                     code: null,
    //                 }
    //             };

    //             const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //             const groupId = res.data?.id;

    //             if (!groupId) {
    //                 showToast("❌ Failed to create group for this category.");
    //                 return;
    //             }

    //             expenseGroup = { id: parseInt(groupId), name: categoryName };
    //         }

    //         // ========== STEP 3: Check if expense type is deferred ==========
    //         const isDeferred = expenseType.is_deferred || false;
    //         let deferredLedgerId = null;

    //         if (isDeferred) {
    //             // Ensure Deferred Expense ledger exists
    //             const deferredLedgerName = `Deferred Expense`;
    //             let deferredLedger = allLedgers.find(l => l.Ledger?.name === deferredLedgerName);

    //             if (deferredLedger) {
    //                 deferredLedgerId = deferredLedger.Ledger.id;
    //             } else {
    //                 const assetGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group
    //                     || allGroups.find(g => g.Group?.name === "Assets")?.Group;

    //                 if (!assetGroup) {
    //                     showToast("❌ 'Current Assets' or 'Assets' group not found.");
    //                     return;
    //                 }

    //                 const ledgerPayload = {
    //                     Ledger: {
    //                         name: deferredLedgerName,
    //                         group_id: assetGroup.id,
    //                         op_balance: 0,
    //                         op_balance_dc: "D",
    //                         notes: "Deferred Expense Ledger (auto-created)",
    //                         code: null,
    //                         type: 0,
    //                         reconciliation: 0,
    //                     }
    //                 };

    //                 const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                 deferredLedgerId = res.data?.data?.Ledger?.id;
    //             }
    //         }

    //         // ========== STEP 4: Ensure expense ledger exists ==========
    //         const expenseLedgerName = expenseType.name;
    //         let expenseLedger = allLedgers.find(l => l.Ledger?.name === expenseLedgerName);
    //         let expenseLedgerId = null;

    //         if (expenseLedger) {
    //             expenseLedgerId = expenseLedger.Ledger.id;
    //         } else {
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: expenseLedgerName,
    //                     group_id: expenseGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "D",
    //                     notes: "",
    //                     code: null,
    //                     type: 0,
    //                     reconciliation: 0,
    //                 }
    //             };

    //             try {
    //                 const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                 expenseLedgerId = res.data?.data?.Ledger?.id;
    //             } catch (err) {
    //                 // Fallback search
    //                 const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //                 const existing = refresh.data?.data?.find(l => l.Ledger?.name === expenseLedgerName);
    //                 expenseLedgerId = existing?.Ledger?.id;

    //                 if (!expenseLedgerId) {
    //                     showToast("❌ Expense ledger exists but ID not found.");
    //                     return;
    //                 }
    //             }
    //         }

    //         // ========== STEP 5: Ensure WPS Charges Ledger exists (Business Operations -> Indirect Expense) ==========
    //         let wpsLedgerId = null;
    //         if (wpsCharge > 0) {
    //             const wpsLedgerName = "WPS Charges";
    //             let wpsLedger = allLedgers.find(l => l.Ledger?.name === wpsLedgerName);

    //             if (wpsLedger) {
    //                 wpsLedgerId = wpsLedger.Ledger.id;
    //             } else {
    //                 // Find 'Business Operations' group under 'Indirect Expenses'
    //                 // First find Indirect Expenses
    //                 let indirectInfo = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
    //                 if (!indirectInfo) {
    //                     // fallback logic or create
    //                     // assume exists for now or user standard
    //                 }

    //                 // Let's try to just find "Business Operations" directly or create it
    //                 let businessOpsGroup = allGroups.find(g => g.Group?.name === "Business Operations")?.Group;

    //                 if (!businessOpsGroup) {
    //                     if (indirectInfo) {
    //                         // Create Business Operations under Indirect Expenses
    //                         const grpPayload = {
    //                             Group: {
    //                                 name: "Business Operations",
    //                                 parent_id: indirectInfo.id,
    //                                 affect_gross: 1,
    //                                 code: null
    //                             }
    //                         };
    //                         const gRes = await axios.post(`${backendUrl}/groups/add`, grpPayload, { headers });
    //                         businessOpsGroup = { id: gRes.data?.id };
    //                     }
    //                 }

    //                 if (businessOpsGroup) {
    //                     const ledgerPayload = {
    //                         Ledger: {
    //                             name: wpsLedgerName,
    //                             group_id: businessOpsGroup.id,
    //                             op_balance: 0,
    //                             op_balance_dc: "D",
    //                             notes: "WPS Charges for Salary",
    //                             code: null,
    //                             type: 0,
    //                             reconciliation: 0,
    //                         }
    //                     };
    //                     const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                     wpsLedgerId = res.data?.data?.Ledger?.id;
    //                 }
    //             }
    //         }

    //         // ========== STEP 6: Ensure Input VAT Ledger exists ==========
    //         let inputVatLedgerId = null;
    //         if (wpsVat > 0) {
    //             const vatLedgerName = "Input VAT";
    //             let vatLedger = allLedgers.find(l => l.Ledger?.name === vatLedgerName);
    //             if (vatLedger) {
    //                 inputVatLedgerId = vatLedger.Ledger.id;
    //             } else {
    //                 // Create Tax Assets group if needed, then Input VAT ledger
    //                 let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;
    //                 if (!taxAssetGroup) {
    //                     const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
    //                     const groupPayload = { Group: { name: "Tax Assets", parent_id: parentAssetsGroup.id, affect_gross: 0, code: null } };
    //                     const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
    //                     taxAssetGroup = { id: res.data?.id };
    //                 }
    //                 const vatPayload = {
    //                     Ledger: {
    //                         name: vatLedgerName,
    //                         group_id: taxAssetGroup.id,
    //                         op_balance: 0,
    //                         op_balance_dc: "D",
    //                         notes: "Input VAT on expenses",
    //                         code: null,
    //                         type: 0,
    //                         reconciliation: 0
    //                     }
    //                 };
    //                 const res = await axios.post(`${backendUrl}/ledgers/add`, vatPayload, { headers });
    //                 inputVatLedgerId = res.data?.data?.Ledger?.id;

    //             }
    //         }


    //         // ========== STEP 7: Build entry items ==========
    //         const entryItems = [];

    //         // Determine which ledger to debit (expense or deferred)
    //         const debitLedgerId = isDeferred ? deferredLedgerId : expenseLedgerId;

    //         // 1. Debit Expense/Deferred Expense Ledger (Salary Amount)
    //         entryItems.push({
    //             dc: "D",
    //             ledger_id: debitLedgerId,
    //             dr_amount: finalAmount.toFixed(2),
    //             cr_amount: null
    //         });

    //         // 2. Debit WPS Charges if applicable
    //         if (wpsCharge > 0 && wpsLedgerId) {
    //             entryItems.push({
    //                 dc: "D",
    //                 ledger_id: wpsLedgerId,
    //                 dr_amount: wpsCharge.toFixed(2),
    //                 cr_amount: null
    //             });
    //         }

    //         // 3. Debit Input VAT if applicable
    //         if (wpsVat > 0 && inputVatLedgerId) {
    //             entryItems.push({
    //                 dc: "D",
    //                 ledger_id: inputVatLedgerId,
    //                 dr_amount: wpsVat.toFixed(2),
    //                 cr_amount: null
    //             });
    //         }

    //         // 4. Credit Salary Payable Ledger (Total of Salary + WPS + VAT)
    //         // Wait, usually payable is just the salary amount payable to employee?
    //         // If WPS charge is bank charge, it might be paid from bank directly or payable to provider?
    //         // "credit is employee payable then the wps chanrge and input vat is here" -> Implies all credit goes to Payable for now?
    //         // Assuming simplified single credit entry to Salary Payable as requested:
    //         const totalCredit = finalAmount + wpsCharge + wpsVat;

    //         entryItems.push({
    //             dc: "C",
    //             ledger_id: salaryPayableLedgerId,
    //             dr_amount: null,
    //             cr_amount: totalCredit.toFixed(2)
    //         });

    //         console.log('📊 Salary Entry Items:', entryItems);

    //         // ========== STEP 8: Create final payload ==========
    //         const narrationWithCurrency = `Salary: ${expenseType.name}`;
    //         const fullNarration = expense.narration || `${narrationWithCurrency} (Entered: ${originalAmount} ${enteredCurrency}${needsConversion ? ', Converted to AED' : ''})`;

    //         const entryPayload = {
    //             Entry: {
    //                 tag_id: null,
    //                 number: generateUniqueEntryNumber(),
    //                 date: expense.date,
    //                 narration: fullNarration,
    //                 client_id: parseInt(expense?.client_id) || null,
    //                 user_id: parseInt(expense?.user_id) || null,
    //                 project_id: parseInt(expense?.project_id) || null,
    //                 is_import: true,
    //             },
    //             Entryitem: entryItems
    //         };

    //         console.log('📤 Salary Entry Payload:', entryPayload);

    //         // ========== STEP 9: Submit entry ==========
    //         try {
    //             const res = await axios.post(`${backendUrl}/entries/add/journal`, entryPayload, { headers });

    //             if (res.data?.status === 'error') {
    //                 showToast(`❌ ${res.data.message || 'Failed to create Salary Expense.'}`);
    //                 return;
    //             }

    //             const webzashEntryId = res.data.entry_id;
    //             console.log(`✅ Salary Expense Journal Created: ${webzashEntryId}`);

    //             // Update expense with journal ID
    //             const backend = process.env.REACT_APP_BACKEND_URL;
    //             const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //             const origin = localStorage.getItem('user-origin');
    //             const token = userInfo?.token;

    //             await axios.post(
    //                 `${backend}/api/expense/${expense.id}/journal`,
    //                 {
    //                     journal_id: webzashEntryId,
    //                     entry_type: "salary_expense",
    //                     // Save currency info for reference
    //                     currency_info: JSON.stringify({
    //                         entered_currency: enteredCurrency,
    //                         original_amount: originalAmount,
    //                         conversion_rate: needsConversion ? conversionRate : 1,
    //                         was_converted: needsConversion,
    //                         accounting_amount: finalAmount,
    //                         accounting_currency: "AED"
    //                     })
    //                 },
    //                 {
    //                     headers: {
    //                         'Authorization': `Bearer ${token}`,
    //                         'Tenant-Origin': origin,
    //                     }
    //                 }
    //             );

    //             showToast1("✅ Salary Expense Created Successfully.");

    //         } catch (err) {
    //             console.error("❌ Error creating salary expense:", err);
    //             showToast("❌ Failed to create Salary Expense.");
    //         }

    //     } catch (error) {
    //         console.error("❌ Error in salary expense creation:", error);
    //         showToast("❌ Error processing salary expense.");
    //     }
    // };
    const createSalaryExpenseEntry = async (expense, allGroups, allLedgers, backendUrl, headers) => {
        try {
            // Get the entered currency (salary expenses should be in AED but handle USD if entered)
            const enteredCurrency = expense.vendor_currency || "AED";

            // Determine if conversion is needed
            let conversionRate = 1;
            let needsConversion = false;

            if (enteredCurrency === "USD") {
                const globalExchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.692);
                conversionRate = globalExchangeRate || process.env.REACT_APP_EXCHANGE_RATE_USD_AED;
                needsConversion = true;
            }

            const expenseType = expense.expense_type;
            const amount = parseFloat(expense.amount) || 0;
            const originalAmount = amount; // Store original amount for reference

            // Parse WPS fields
            const wpsCharge = parseFloat(expense.wps_charge) || 0;
            const wpsVat = parseFloat(expense.wps_vat) || 0;

            if (!expenseType || amount <= 0) {
                showToast("❌ Missing expense type or invalid amount for salary expense.");
                return;
            }

            // Convert all amounts to AED for accounting
            const finalAmount = parseFloat((amount * conversionRate).toFixed(2));
            const finalWpsCharge = parseFloat((wpsCharge * conversionRate).toFixed(2));
            const finalWpsVat = parseFloat((wpsVat * conversionRate).toFixed(2));

            console.log(`💼 Salary Expense Details:`);
            console.log(`- Salary Amount: ${amount} ${enteredCurrency} = ${finalAmount} AED`);
            console.log(`- WPS Charge: ${wpsCharge} ${enteredCurrency} = ${finalWpsCharge} AED`);
            console.log(`- WPS VAT: ${wpsVat} ${enteredCurrency} = ${finalWpsVat} AED`);
            console.log(`- Total Credit: ${finalAmount + finalWpsCharge + finalWpsVat} AED`);

            // ========== STEP 1: Ensure Salary Payable ledger exists ==========
            const salaryPayableLedgerName = "Salary Payable";
            let salaryPayableLedger = allLedgers.find(l => l.Ledger?.name === salaryPayableLedgerName);
            let salaryPayableLedgerId = null;

            if (salaryPayableLedger) {
                salaryPayableLedgerId = salaryPayableLedger.Ledger.id;
            } else {
                // Find Current Liabilities group
                let currentLiabilitiesGroup = allGroups.find(g =>
                    g.Group?.name === "Current Liabilities"
                )?.Group;

                // If Current Liabilities doesn't exist, create it under Liabilities
                if (!currentLiabilitiesGroup) {
                    const liabilitiesGroup = allGroups.find(g =>
                        g.Group?.name === "Liabilities and Owners Equity"
                    )?.Group;

                    if (!liabilitiesGroup) {
                        showToast("❌ 'Liabilities and Owners Equity' group not found.");
                        return;
                    }

                    const groupPayload = {
                        Group: {
                            name: "Current Liabilities",
                            parent_id: liabilitiesGroup.id,
                            affect_gross: 0,
                            code: null,
                        }
                    };

                    const groupRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
                    const newGroupId = groupRes.data?.id;

                    if (!newGroupId) {
                        showToast("❌ Failed to create Current Liabilities group.");
                        return;
                    }

                    // Refresh groups
                    const refresh = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = refresh.data;
                    currentLiabilitiesGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
                }

                // Create Salary Payable ledger
                const ledgerPayload = {
                    Ledger: {
                        name: salaryPayableLedgerName,
                        group_id: currentLiabilitiesGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C", // Credit balance for liability account
                        notes: "Salary payable to employees",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };

                try {
                    const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    salaryPayableLedgerId = res.data?.data?.Ledger?.id;

                    // Refresh ledgers
                    const ledgerRefresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    allLedgers = ledgerRefresh.data?.data;
                } catch (err) {
                    console.error("Error creating Salary Payable ledger:", err);
                    showToast("❌ Failed to create Salary Payable ledger.");
                    return;
                }
            }

            // ========== STEP 2: Ensure expense category group exists ==========
            const categoryName = expenseType.category?.name;
            const categoryGroupId = expenseType.category?.group_id;
            let expenseGroup = allGroups.find(g => g.Group?.name === categoryName)?.Group;

            if (!expenseGroup && categoryGroupId) {
                const groupPayload = {
                    Group: {
                        name: categoryName,
                        parent_id: categoryGroupId,
                        affect_gross: 1,
                        code: null,
                    }
                };

                const res = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
                const groupId = res.data?.id;

                if (groupId) {
                    expenseGroup = { id: parseInt(groupId), name: categoryName };
                }
            }

            if (!expenseGroup) {
                showToast("❌ Could not find or create expense category group.");
                return;
            }


            // ========== STEP 4: Ensure expense ledger exists ==========
            const expenseLedgerName = expenseType.name;
            let expenseLedger = allLedgers.find(l => l.Ledger?.name === expenseLedgerName);
            let expenseLedgerId = null;

            if (expenseLedger) {
                expenseLedgerId = expenseLedger.Ledger.id;
            } else {
                const ledgerPayload = {
                    Ledger: {
                        name: expenseLedgerName,
                        group_id: expenseGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                };

                try {
                    const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    expenseLedgerId = res.data?.data?.Ledger?.id;
                } catch (err) {
                    // Try to find existing ledger
                    const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refresh.data?.data?.find(l => l.Ledger?.name === expenseLedgerName);
                    expenseLedgerId = existing?.Ledger?.id;

                    if (!expenseLedgerId) {
                        showToast("❌ Expense ledger exists but ID not found.");
                        return;
                    }
                }
            }

            // ========== STEP 5: Ensure WPS Charges ledger exists ==========
            let wpsLedgerId = null;
            if (finalWpsCharge > 0) {
                const wpsLedgerName = "WPS Charges";
                let wpsLedger = allLedgers.find(l => l.Ledger?.name === wpsLedgerName);

                if (wpsLedger) {
                    wpsLedgerId = wpsLedger.Ledger.id;
                } else {
                    // Try to find Business Operations group
                    let businessOpsGroup = allGroups.find(g =>
                        g.Group?.name === "Business Operation"
                    )?.Group;

                    // If not found, try Indirect Expenses
                    if (!businessOpsGroup) {
                        const indirectGroup = allGroups.find(g =>
                            g.Group?.name === "Indirect Expenses"
                        )?.Group;

                        if (!indirectGroup) {
                            showToast("❌ 'Indirect Expenses' group not found.");
                            return;
                        }

                        // Create Business Operations group
                        const grpPayload = {
                            Group: {
                                name: "Business Operation",
                                parent_id: indirectGroup.id,
                                affect_gross: 1,
                                code: null
                            }
                        };

                        try {
                            const gRes = await axios.post(`${backendUrl}/groups/add`, grpPayload, { headers });
                            businessOpsGroup = { id: gRes.data?.id };
                        } catch (error) {
                            console.error("Error creating Business Operations group:", error);
                            // Fallback to Indirect Expenses directly
                            businessOpsGroup = indirectGroup;
                        }
                    }

                    // Create WPS Charges ledger
                    const ledgerPayload = {
                        Ledger: {
                            name: wpsLedgerName,
                            group_id: businessOpsGroup.id,
                            op_balance: 0,
                            op_balance_dc: "D",
                            notes: "WPS Charges for salary processing",
                            code: null,
                            type: 0,
                            reconciliation: 0,
                        }
                    };

                    try {
                        const res = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                        wpsLedgerId = res.data?.data?.Ledger?.id;
                    } catch (error) {
                        console.error("Error creating WPS Charges ledger:", error);
                        showToast("❌ Failed to create WPS Charges ledger.");
                        return;
                    }
                }
            }

            // ========== STEP 6: Ensure Input VAT ledger exists ==========
            let inputVatLedgerId = null;
            if (finalWpsVat > 0) {
                const vatLedgerName = "Input VAT";
                let vatLedger = allLedgers.find(l => l.Ledger?.name === vatLedgerName);

                if (vatLedger) {
                    inputVatLedgerId = vatLedger.Ledger.id;
                } else {
                    // Find or create Tax Assets group
                    let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;

                    if (!taxAssetGroup) {
                        const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;

                        if (!parentAssetsGroup) {
                            showToast("❌ 'Assets' group not found.");
                            return;
                        }

                        const groupPayload = {
                            Group: {
                                name: "Tax Assets",
                                parent_id: parentAssetsGroup.id,
                                affect_gross: 0,
                                code: null
                            }
                        };

                        const gRes = await axios.post(`${backendUrl}/groups/add`, groupPayload, { headers });
                        taxAssetGroup = { id: gRes.data?.id };
                    }

                    // Create Input VAT ledger
                    const vatPayload = {
                        Ledger: {
                            name: vatLedgerName,
                            group_id: taxAssetGroup.id,
                            op_balance: 0,
                            op_balance_dc: "D",
                            notes: "Input VAT on expenses",
                            code: null,
                            type: 0,
                            reconciliation: 0
                        }
                    };

                    try {
                        const res = await axios.post(`${backendUrl}/ledgers/add`, vatPayload, { headers });
                        inputVatLedgerId = res.data?.data?.Ledger?.id;
                    } catch (error) {
                        console.error("Error creating Input VAT ledger:", error);
                        showToast("❌ Failed to create Input VAT ledger.");
                        return;
                    }
                }
            }

            // ========== STEP 7: Build journal entry items ==========
            const entryItems = [];

            // Determine which ledger to debit for salary (expense or deferred)
            const debitLedgerId = expenseLedgerId;

            // 1. Debit: Salary Expense (or Deferred Expense)
            entryItems.push({
                dc: "D",
                ledger_id: debitLedgerId,
                dr_amount: finalAmount.toFixed(2),
                cr_amount: null
            });

            // 2. Debit: WPS Charges (if any)
            if (finalWpsCharge > 0 && wpsLedgerId) {
                entryItems.push({
                    dc: "D",
                    ledger_id: wpsLedgerId,
                    dr_amount: finalWpsCharge.toFixed(2),
                    cr_amount: null
                });
            }

            // 3. Debit: Input VAT (if any)
            if (finalWpsVat > 0 && inputVatLedgerId) {
                entryItems.push({
                    dc: "D",
                    ledger_id: inputVatLedgerId,
                    dr_amount: finalWpsVat.toFixed(2),
                    cr_amount: null
                });
            }

            // 4. Credit: Salary Payable (total of all debits)
            const totalCredit = finalAmount + finalWpsCharge + finalWpsVat;
            entryItems.push({
                dc: "C",
                ledger_id: salaryPayableLedgerId,
                dr_amount: null,
                cr_amount: totalCredit.toFixed(2)
            });

            console.log('📊 Salary Journal Entry Items:');
            console.log('- Debit Salary Expense:', finalAmount.toFixed(2));
            console.log('- Debit WPS Charges:', finalWpsCharge.toFixed(2));
            console.log('- Debit Input VAT:', finalWpsVat.toFixed(2));
            console.log('- Credit Salary Payable:', totalCredit.toFixed(2));

            // ========== STEP 8: Create final payload ==========
            const payrollProvider = expense.payroll_provider || expense.payroll_provider_id;
            const narration = expense.narration ||
                `Salary expense: ${expenseType.name}${payrollProvider ? ` via ${payrollProvider}` : ''} (${enteredCurrency})`;

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: generateUniqueEntryNumber(),
                    date: expense.date,
                    narration: narration,
                    client_id: parseInt(expense?.client_id) || null,
                    user_id: parseInt(expense?.user_id) || null,
                    project_id: parseInt(expense?.project_id) || null,
                    is_import: true,
                },
                Entryitem: entryItems
            };

            console.log('📤 Salary Entry Payload:', entryPayload);

            // ========== STEP 9: Submit entry ==========
            try {
                const res = await axios.post(`${backendUrl}/entries/add/journal`, entryPayload, { headers });

                if (res.data?.status === 'error') {
                    showToast(`❌ ${res.data.message || 'Failed to create Salary Expense.'}`);
                    return;
                }

                const webzashEntryId = res.data.entry_id;
                console.log(`✅ Salary Expense Journal Created: ${webzashEntryId}`);

                // Update expense with journal ID
                const backend = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                await axios.post(
                    `${backend}/api/expense/${expense.id}/journal`,
                    {
                        journal_id: webzashEntryId,
                        entry_type: "salary_expense",
                        currency_info: JSON.stringify({
                            entered_currency: enteredCurrency,
                            original_salary_amount: amount,
                            original_wps_charge: wpsCharge,
                            original_wps_vat: wpsVat,
                            conversion_rate: conversionRate,
                            accounting_salary_amount: finalAmount,
                            accounting_wps_charge: finalWpsCharge,
                            accounting_wps_vat: finalWpsVat,
                            accounting_currency: "AED"
                        })
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        }
                    }
                );

                showToast1("✅ Salary Expense Created Successfully.");

            } catch (err) {
                console.error("❌ Error creating salary expense:", err);
                showToast("❌ Failed to create Salary Expense.");
            }

        } catch (error) {
            console.error("❌ Error in salary expense creation:", error);
            showToast("❌ Error processing salary expense.");
        }
    };

    const createDeferredExpenseEntry = async (expense, allGroups, allLedgers, backendUrl, headers) => {
        try {
            const enteredCurrency = expense.vendor_currency || "AED";
            let conversionRate = 1;
            let needsConversion = false;

            if (enteredCurrency === "USD") {
                conversionRate = parseFloat(localStorage.getItem('exchange_rate') || 3.692);
                needsConversion = true;
            }

            const vendor = expense.vendor;
            const user = expense.user || (expense.user_id
                ? users.find(u => String(u.id) === String(expense.user_id))
                : null);

            if (!vendor && !user) {
                showToast("❌ Missing vendor or user for deferred expense.");
                return;
            }

            // ── STEP 1: Ensure Deferred Expense ledger exists (under Current Assets) ──
            const deferredLedgerName = "Deferred Expense";
            let deferredLedger = allLedgers.find(l => l.Ledger?.name === deferredLedgerName);
            let deferredLedgerId = null;

            if (deferredLedger) {
                deferredLedgerId = deferredLedger.Ledger.id;
            } else {
                const assetGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group
                    || allGroups.find(g => g.Group?.name === "Assets")?.Group;

                if (!assetGroup) {
                    showToast("❌ 'Current Assets' or 'Assets' group not found.");
                    return;
                }

                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: deferredLedgerName,
                        group_id: assetGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Deferred Expense - prepaid amount to be recognized over time",
                        code: null,
                        type: 0,
                        reconciliation: 0,
                    }
                }, { headers });
                deferredLedgerId = res.data?.data?.Ledger?.id;

                if (!deferredLedgerId) {
                    showToast("❌ Failed to create Deferred Expense ledger.");
                    return;
                }
            }

            // ── STEP 2: Calculate amounts ──
            let expenseAmount = 0;
            let vatAmount = 0;
            const adjustmentAmount = parseFloat(expense.adjustment_amount || 0);

            if (expense.tax_type === 'taxable') {
                const base = parseFloat(expense.amount_without_tax || 0);
                expenseAmount = parseFloat((base * conversionRate).toFixed(2));

                const rawVat = expense.vat_amount;
                if (rawVat !== null && rawVat !== undefined && rawVat !== '') {
                    vatAmount = parseFloat((parseFloat(rawVat) * conversionRate).toFixed(2));
                } else {
                    const taxRate = parseFloat(expense.tax || 5) / 100;
                    vatAmount = parseFloat((expenseAmount * taxRate).toFixed(2));
                }
            } else {
                expenseAmount = parseFloat((parseFloat(expense.amount || 0) * conversionRate).toFixed(2));
                vatAmount = 0;
            }

            const convertedAdjustment = parseFloat((adjustmentAmount * conversionRate).toFixed(2));
            const totalCreditAmount = expenseAmount + vatAmount + convertedAdjustment;

            console.log(`📊 Deferred Expense Amounts:
  Base: ${expenseAmount} AED
  VAT: ${vatAmount} AED
  Adjustment: ${convertedAdjustment} AED
  Total Credit: ${totalCreditAmount} AED
  Schedule: ${expense.recognition_period} | ${expense.deferred_start_date} → ${expense.deferred_end_date}
  Periods: ${expense.total_periods} | Per Period: ${expense.amount_per_period}`);

            // ── STEP 3: Handle Input VAT ledger if taxable ──
            let inputVATLedgerId = null;
            if (vatAmount > 0) {
                let taxAssetGroup = allGroups.find(g => g.Group?.name === "Tax Assets")?.Group;

                if (!taxAssetGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    if (!parentAssetsGroup) {
                        showToast("❌ 'Assets' group not found.");
                        return;
                    }
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Tax Assets",
                            parent_id: parentAssetsGroup.id,
                            affect_gross: 0,
                            code: null
                        }
                    }, { headers });
                    taxAssetGroup = { id: parseInt(res.data?.id), name: "Tax Assets" };
                }

                const inputVATLedgerName = "Input VAT";
                let inputVATLedger = allLedgers.find(l => l.Ledger?.name === inputVATLedgerName);

                if (!inputVATLedger) {
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name: inputVATLedgerName,
                            group_id: taxAssetGroup.id,
                            op_balance: 0,
                            op_balance_dc: "D",
                            notes: "",
                            code: null,
                            type: 0,
                            reconciliation: 0,
                        }
                    }, { headers });
                    inputVATLedgerId = res.data?.data?.Ledger?.id;
                } else {
                    inputVATLedgerId = inputVATLedger.Ledger.id;
                }
            }

            // ── STEP 4: Find or create Credit Ledger (Vendor/User) ──
            let creditLedgerId = null;
            let creditLedgerName = "";
            let creditLedgerGroupName = "";

            if (vendor) {
                creditLedgerName = vendor.name;
                creditLedgerGroupName = "Sundry Creditors (Vendors)";
            } else if (user) {
                creditLedgerName = user.name;
                creditLedgerGroupName = "Loans (Liabilities)";
            }

            let creditGroup = allGroups.find(g => g.Group?.name === creditLedgerGroupName)?.Group;

            if (!creditGroup) {
                const parentLiabilitiesGroup = allGroups.find(
                    g => g.Group?.name === "Liabilities and Owners Equity"
                )?.Group;

                if (!parentLiabilitiesGroup) {
                    showToast("❌ 'Liabilities and Owners Equity' group not found.");
                    return;
                }

                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                    Group: {
                        name: creditLedgerGroupName,
                        parent_id: parentLiabilitiesGroup.id,
                        affect_gross: 0,
                        code: null
                    }
                }, { headers });

                const newGroupId = groupRes.data?.id;
                if (!newGroupId) {
                    showToast(`❌ Failed to create group '${creditLedgerGroupName}'.`);
                    return;
                }

                const groupRes2 = await axios.get(`${backendUrl}/groups/index`, { headers });
                allGroups = groupRes2.data;
                creditGroup = allGroups.find(g => g.Group?.id == newGroupId)?.Group;
            }

            let creditLedger = allLedgers.find(l => l.Ledger?.name === creditLedgerName);

            if (creditLedger) {
                creditLedgerId = creditLedger.Ledger.id;
            } else {
                try {
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name: creditLedgerName,
                            group_id: creditGroup.id,
                            op_balance: 0,
                            op_balance_dc: "C",
                            notes: "",
                            code: null,
                            type: 0,
                            reconciliation: 0,
                        }
                    }, { headers });
                    creditLedgerId = res.data?.data?.Ledger?.id;
                } catch (err) {
                    const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refresh.data?.data?.find(l => l.Ledger?.name === creditLedgerName);
                    creditLedgerId = existing?.Ledger?.id;
                }
            }

            if (!creditLedgerId) {
                showToast("❌ Credit ledger not found. Cannot proceed.");
                return;
            }

            // ── STEP 5: Build journal entry items ──
            // DEBIT: Deferred Expense (Asset) - NOT the expense type ledger
            // CREDIT: Vendor
            const entryItems = [];

            // 1. Debit Deferred Expense (Asset ledger)
            entryItems.push({
                dc: "D",
                ledger_id: deferredLedgerId,
                dr_amount: expenseAmount.toFixed(2),
                cr_amount: null
            });

            // 2. Debit Input VAT if taxable
            if (vatAmount > 0 && inputVATLedgerId) {
                entryItems.push({
                    dc: "D",
                    ledger_id: inputVATLedgerId,
                    dr_amount: vatAmount.toFixed(2),
                    cr_amount: null
                });
            }

            // 3. Debit Adjustment if applicable
            if (convertedAdjustment !== 0 && convertedAdjustment) {
                // Need adjustment ledger - find or create
                const adjustmentLedgerName = "Adjustment Charges";
                let adjustmentLedger = allLedgers.find(l => l.Ledger?.name === adjustmentLedgerName);
                let adjustmentLedgerId = null;

                if (adjustmentLedger) {
                    adjustmentLedgerId = adjustmentLedger.Ledger.id;
                } else {
                    let indirectGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                    if (indirectGroup) {
                        const res = await axios.post(`${backendUrl}/ledgers/add`, {
                            Ledger: {
                                name: adjustmentLedgerName,
                                group_id: indirectGroup.id,
                                op_balance: 0,
                                op_balance_dc: "D",
                                notes: "Expense adjustment amount",
                                code: null,
                                type: 0,
                                reconciliation: 0,
                            }
                        }, { headers });
                        adjustmentLedgerId = res.data?.data?.Ledger?.id;
                    }
                }

                if (adjustmentLedgerId) {
                    const isNegative = convertedAdjustment < 0;
                    entryItems.push({
                        dc: isNegative ? "C" : "D",
                        ledger_id: adjustmentLedgerId,
                        dr_amount: isNegative ? null : Math.abs(convertedAdjustment).toFixed(2),
                        cr_amount: isNegative ? Math.abs(convertedAdjustment).toFixed(2) : null
                    });
                }
            }

            // 4. Credit Vendor (Liability)
            entryItems.push({
                dc: "C",
                ledger_id: creditLedgerId,
                dr_amount: null,
                cr_amount: totalCreditAmount.toFixed(2)
            });

            // ── STEP 6: Create journal entry payload ──
            const narration = expense.narration ||
                `Deferred Expense: ${expense.expense_type?.name || ''} - ${expense.recognition_period} over ${expense.total_periods} periods (${expense.deferred_start_date} to ${expense.deferred_end_date})`;

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: generateUniqueEntryNumber(),
                    date: expense.date,
                    narration: narration,
                    client_id: parseInt(expense?.client_id) || parseInt(expense?.project?.client_id) || null,
                    user_id: parseInt(user?.id || expense?.user_id) || null,
                    project_id: parseInt(expense?.project_id) || null,
                    is_import: true,
                },
                Entryitem: entryItems
            };

            console.log('📤 Deferred Expense Journal Payload:', entryPayload);

            // ── STEP 7: Submit entry ──
            const res = await axios.post(
                `${backendUrl}/entries/add/journal`,
                entryPayload,
                { headers }
            );

            if (res.data?.status === 'error') {
                showToast(`❌ ${res.data.message || 'Failed to create Deferred Expense journal.'}`);
                return;
            }

            const webzashEntryId = res.data.entry_id;
            console.log(`✅ Deferred Expense Journal Created: #${webzashEntryId}`);

            // ── STEP 8: Save journal ID back to expense ──
            const backend = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.post(
                `${backend}/api/expense/${expense.id}/journal`,
                {
                    journal_id: webzashEntryId,
                    entry_type: "deferred_expense",
                    deferred_info: JSON.stringify({
                        recognition_period: expense.recognition_period,
                        deferred_start_date: expense.deferred_start_date,
                        deferred_end_date: expense.deferred_end_date,
                        total_periods: expense.total_periods,
                        amount_per_period: expense.amount_per_period,
                        currency: enteredCurrency,
                        conversion_rate: conversionRate,
                        accounting_currency: "AED",
                        journal_entry: {
                            debit_deferred_expense: expenseAmount,
                            debit_input_vat: vatAmount,
                            credit_vendor: totalCreditAmount
                        }
                    })
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                }
            );

            showToast1("✅ Deferred Expense Created Successfully.");

        } catch (error) {
            console.error("❌ Error in deferred expense creation:", error);
            showToast("❌ Failed to create Deferred Expense.");
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/expense/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            if (response.data.warnings && response.data.warnings.length > 0) {
                response.data.warnings.forEach((warning, index) => {
                    setTimeout(() => {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'warning',
                            title: warning,
                            timer: 4000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                            didOpen: () => {
                                const container = Swal.getContainer();
                                container.style.top = '50px';
                            },
                        });
                    }, index * 500); // staggered display
                });
            }

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1500);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };
    const formatUSCurrency = (amount) => {
        if (!amount && amount !== 0) return '0.00';
        return parseFloat(amount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const params = new URLSearchParams();
            if (searchQuery) params.append('search', searchQuery);
            if (projectFilter === 'no-project') {
                params.append('no_project', 'true');
            } else if (projectFilter) {
                params.append('project_id', projectFilter);
            }
            if (expenseTypeFilter) params.append('expense_type_id', expenseTypeFilter);
            if (userFilter) params.append('user_id', userFilter);
            if (startDateFilter) params.append('from_date', startDateFilter);
            if (endDateFilter) params.append('to_date', endDateFilter);
            if (typeFilter) params.append('type', typeFilter);
            if (Array.isArray(sourceFilter) && sourceFilter.length > 0) {
                params.append('source', sourceFilter.join(','));
            } else if (sourceFilter && sourceFilter !== 'all' && !Array.isArray(sourceFilter)) {
                params.append('source', sourceFilter);
            }
            if (attachmentFilter === 'without') {
                params.append('attachment_null', 'true');
            } else if (attachmentFilter === 'with') {
                params.append('attachment_not_null', 'true');
            }
            if (summaryFilter && summaryFilter !== 'all') {
                params.append('tax_type', summaryFilter);
            }

            const response = await axios.get(
                `${backendUrl}/api/expense/export?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Expenses_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Expenses</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title mb-3">
                                        <FaFilter className="me-2" />
                                        Filters
                                    </h5>
                                    <div className="row g-2">
                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Date Range</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={dateRangeFilter}
                                                onChange={(e) => handleDateRangeChange(e.target.value)}
                                            >
                                                <option value="yearly">Yearly</option>
                                                <option value="custom">Custom Range</option>
                                            </select>
                                        </div>

                                        {dateRangeFilter === 'yearly' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    if (!startDateFilter || dayjs(startDateFilter).year() !== newValue.year()) {
                                                                        const start = newValue.startOf('year');
                                                                        setStartDateFilter(start.format('YYYY-MM-DD'));
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                        setSelectedEndYear(newValue);
                                                                    } else {
                                                                        setStartDateFilter(newValue.format('YYYY-MM-DD'));
                                                                        if (endDateFilter && dayjs(newValue.format('YYYY-MM-DD')).isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(newValue.format('YYYY-MM-DD')).endOf('month').format('YYYY-MM-DD'));
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    setSelectedEndYear(newValue);
                                                                    if (!endDateFilter || dayjs(endDateFilter).year() !== newValue.year()) {
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                    } else {
                                                                        const dateStr = newValue.format('YYYY-MM-DD');
                                                                        if (startDateFilter && dayjs(dateStr).isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                        } else {
                                                                            setEndDateFilter(dateStr);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}

                                        {dateRangeFilter === 'custom' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                                setStartDateFilter(dateStr);
                                                                if (newValue && endDateFilter && newValue.isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(newValue.endOf('month').format('YYYY-MM-DD'));
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue && startDateFilter && newValue.isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                } else {
                                                                    setEndDateFilter(newValue ? newValue.format("YYYY-MM-DD") : "");
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}


                                        {/* Attachment Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Attachment</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={attachmentFilter}
                                                onChange={(e) => setAttachmentFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All Attachments</option>
                                                <option value="with" className='font-size-11'>With Attachment</option>
                                                <option value="without" className='font-size-11'>Without Attachment</option>
                                            </select>
                                        </div>

                                        {/* Payment Status Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Payment Status</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All</option>
                                                <option value="Paid" className='font-size-11'>Paid</option>
                                                <option value="Unpaid" className='font-size-11'>Unpaid</option>
                                                <option value="Partial" className='font-size-11'>Partial</option>
                                            </select>
                                        </div>

                                        {/* Source Filter */}
                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Expense Type</label>
                                            <Select
                                                isMulti
                                                options={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ]}
                                                value={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ].filter(option => sourceFilter.includes(option.value))}
                                                onChange={(selectedOptions) => {
                                                    setSourceFilter(selectedOptions ? selectedOptions.map(option => option.value) : []);
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '31px',
                                                        fontSize: '11px',
                                                        borderColor: '#ced4da',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#b3b3b3' }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '11px'
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: '0px 8px',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '31px'
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#e9ecef',
                                                        margin: '1px'
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        fontSize: '10px',
                                                        padding: '1px 4px',
                                                        color: '#495057'
                                                    })
                                                }}
                                                placeholder="Select Type..."
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                        {/* Tax Type Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Tax Type</label>
                                            <select
                                                className="form-select"
                                                value={summaryFilter}
                                                onChange={(e) => setSummaryFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All Tax Types</option>
                                                <option value="taxable" className='font-size-11'>Taxable</option>
                                                <option value="non-taxable" className='font-size-11'>Non-Taxable</option>
                                            </select>
                                        </div>

                                     
                                      

                                        {/* User Filter */}
                                        <div className="col-md-1 mt-2">
                                            <label className="form-label font-size-11 mb-1">User</label>
                                            <select
                                                className="form-select"
                                                value={userFilter}
                                                onChange={(e) => handleFilterChange('user', e.target.value)}
                                            >
                                                <option value="">All Users</option>
                                                {users.map((u) => (
                                                    <option key={u.id} value={u.id}>{u.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Vendor Filter */}
                                        <div className="col-md-1 mt-2">
                                            <label className="form-label font-size-11 mb-1">Vendor/Client</label>
                                            <select
                                                className="form-select"
                                                value={vendorFilter}
                                                onChange={(e) => handleFilterChange('vendor', e.target.value)}
                                            >
                                                <option value="">All Vendors</option>
                                                {vendors.map((v) => (
                                                    <option key={v.id} value={v.id}>{v.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row g-2 mt-2">
                                        <div className="col-md-9">
                                            <InputGroup size="sm">
                                                <InputGroup.Text className="bg-light border-end-0">
                                                    <FiSearch className="text-muted" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    className="bg-light border-start-0"
                                                    placeholder="Search expenses by narration or reference..."
                                                    value={searchQuery}
                                                    onChange={handleSearchChange}
                                                />
                                            </InputGroup>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="d-flex gap-1">
                                                <button
                                                    className="btn btn-primary btn-sm font-size-11 flex-fill"
                                                    onClick={applyFilters}
                                                >
                                                    <FaFilter className="me-1" />
                                                    Apply
                                                </button>

                                                <button
                                                    className="btn btn-secondary btn-sm font-size-11 flex-fill"
                                                    onClick={clearAllFilters}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>


                                    </div>

                                    {(startDateFilter || endDateFilter || projectFilter || expenseTypeFilter || userFilter || searchQuery || statusFilter !== 'all' || attachmentFilter !== 'all' || summaryFilter !== 'all') && (
                                        <div className="mt-2">
                                            <small className="text-muted">Active Filters:</small>
                                            <div className="d-flex flex-wrap gap-1 mt-1">
                                                {startDateFilter && endDateFilter && dayjs(startDateFilter).isSame(dayjs(endDateFilter).startOf('year'), 'day') && dayjs(endDateFilter).isSame(dayjs(startDateFilter).endOf('year'), 'day') ? (
                                                    <span className="badge bg-info">
                                                        Period: {dayjs(startDateFilter).format('MMM YYYY')} – {dayjs(endDateFilter).format('MMM YYYY')}
                                                    </span>
                                                ) : (
                                                    <>
                                                        {startDateFilter && (
                                                            <span className="badge bg-info">
                                                                From: {dayjs(startDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                        {endDateFilter && (
                                                            <span className="badge bg-info">
                                                                To: {dayjs(endDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                                {projectFilter && (
                                                    <span className="badge bg-warning text-dark">
                                                        Project: {projectFilter === 'no-project' ? 'No Project' : projects.find(p => p.id == projectFilter)?.name}
                                                    </span>
                                                )}
                                                {expenseTypeFilter && (
                                                    <span className="badge bg-success">
                                                        Type: {expenseTypes.find(t => t.id == expenseTypeFilter)?.name}
                                                    </span>
                                                )}
                                                {userFilter && (
                                                    <span className="badge bg-secondary">
                                                        User: {users.find(u => u.id == userFilter)?.name}
                                                    </span>
                                                )}
                                                {searchQuery && (
                                                    <span className="badge bg-primary">
                                                        Search: "{searchQuery}"
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Box */}
                    {showSummaryBox && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="card-title mb-0">Expense Summary</h5>
                                            <div>
                                                <span className="badge bg-info me-2">
                                                    Total: {summaryData.total_count} expenses
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => setShowSummaryBox(false)}
                                                >
                                                    Hide
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Total Amount */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">
                                                            {isSalarySearch ? 'Amount (Excl. WPS & VAT)' : 'Total Amount (excl. VAT)'}
                                                        </small>
                                                        <h5 className="mb-0 text-primary">
                                                            {formatCurrency(summaryData.total_amount)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Standard VAT Amount */}
                                            {isStandardSearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total VAT (5%)</small>
                                                            <h5 className="mb-0 text-success">
                                                                {formatCurrency(summaryData.total_vat)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* WPS VAT Summary (Salary Only) */}
                                            {isSalarySearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total WPS VAT</small>
                                                            <h5 className="mb-0 text-success">
                                                                {formatCurrency(summaryData.total_wps_vat)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* WPS Charge Summary (Salary Only) */}
                                            {isSalarySearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total WPS Charge</small>
                                                            <h5 className="mb-0 text-info">
                                                                {formatCurrency(summaryData.total_wps_charge)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Total Adjustment */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Adjustment</small>
                                                        <h5 className="mb-0 text-warning">
                                                            {formatCurrency(summaryData.total_adjustment)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Grand Total */}
                                            <div className="col-md-2">
                                                <div className="card bg-light text-white">
                                                    <div className="card-body p-2">
                                                        <small className="d-block text-muted">Grand Total</small>
                                                        <h5 className="mb-0 text-success">
                                                            {formatCurrency(summaryData.grand_total)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Unpaid */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Unpaid</small>
                                                        <h5 className="mb-0 text-dark">
                                                            {formatCurrency(summaryData.total_unpaid || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Paid */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Paid</small>
                                                        <h5 className="mb-0 text-success">
                                                            {formatCurrency(summaryData.total_paid || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Balance */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Balance</small>
                                                        <h5 className="mb-0 text-danger">
                                                            {formatCurrency(summaryData.total_balance || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tax Breakdown */}
                                            {/* <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">
                                                                {isSalarySearch ? 'Taxable (WPS):' : 'Taxable:'}
                                                            </small>
                                                            <small className="text-success">{summaryData.taxable_count}</small>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">
                                                                {isSalarySearch ? 'Non-Taxable (WPS):' : 'Non-Taxable:'}
                                                            </small>
                                                            <small className="text-info">{summaryData.non_taxable_count}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* If summary is hidden, show toggle button */}
                    {!showSummaryBox && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setShowSummaryBox(true)}
                                >
                                    <FaFilter className="me-1" />
                                    Show Summary & Filters
                                </button>
                            </div>
                        </div>
                    )}




                    {/* Instance Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-end mb-3">
                                        <div className="d-flex">
                                            {/* Removed search box from here */}
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                    onClick={() => handleShowModal(null, "edit")}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Expense"
                                                >
                                                    <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>

                                    </div>


                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '50px' }} className="align-middle text-center">#</th>
                                                    <th className='align-middle'>Description</th>

                                                    <th className="align-middle">Date <div className="dropdown d-inline-block">
                                                        <FaFilter
                                                            className="ms-2 cursor-pointer filter-color"
                                                            onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                        />
                                                        {dateFilterDropdown && (
                                                            <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                <label className="form-label">From</label>
                                                                <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

                                                                <label className="form-label">To</label>
                                                                <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

                                                                <div className="text-end mt-3">
                                                                    <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
                                                                        Apply
                                                                    </button>
                                                                    <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div></th>
                                                    <th className="align-middle">Expense Type
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'expenseType' ? null : 'expenseType')}
                                                            />
                                                            {filterDropdown === 'expenseType' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('expenseType', '')}>All</button></li>
                                                                    {expenseTypes.map((type) => (
                                                                        <li key={type.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('expenseType', type.id)}>
                                                                                {type.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">Client/Supplier
                                                         <div className="dropdown d-inline-block">
                                                             <FaFilter
                                                                 className="ms-2 cursor-pointer filter-color"
                                                                 onClick={() => setFilterDropdown(filterDropdown === 'vendor' ? null : 'vendor')}
                                                             />
                                                             {filterDropdown === 'vendor' && (
                                                                 <ul className="dropdown-menu show">
                                                                     <li><button className="dropdown-item" onClick={() => handleFilterChange('vendor', '')}>All</button></li>
                                                                     {vendors.map((v) => (
                                                                         <li key={v.id}>
                                                                             <button className="dropdown-item" onClick={() => handleFilterChange('vendor', v.id)}>
                                                                                 {v.name}
                                                                             </button>
                                                                         </li>
                                                                     ))}
                                                                 </ul>
                                                             )}
                                                         </div>
                                                     </th>

                                                    <th className="align-middle">Project
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'project' ? null : 'project')}
                                                            />
                                                            {filterDropdown === 'project' && (
                                                                <ul className="dropdown-menu show ">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('project', '')}>All</button></li>
                                                                    <li>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleFilterChange('project', 'no-project')}
                                                                        >
                                                                            No Project
                                                                        </button>
                                                                    </li>
                                                                    {projects.map((proj) => (
                                                                        <li key={proj.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('project', proj.id)}>
                                                                                {proj.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>


                                                    <th className="align-middle">
                                                        User
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'user' ? null : 'user')}
                                                            />
                                                            {filterDropdown === 'user' && (
                                                                <ul className="dropdown-menu show ">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('user', '')}>All</button></li>
                                                                    {users.map((usr) => (
                                                                        <li key={usr.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('user', usr.id)}>
                                                                                {usr.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">Type
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
                                                            />
                                                            {filterDropdown === 'type' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
                                                                            All
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'taxable')}>
                                                                            Taxable
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'non-taxable')}>
                                                                            Non-Taxable
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle text-end">Amount</th>
                                                    <th className="align-middle text-end" style={{ width: '80px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {expenses.length > 0 ? (
                                                    expenses.map((expense, index) => {
                                                        const isReversed = expense.reconciliation_status === 'reversed';

                                                        return (
                                                            <tr key={expense.id}>
                                                                <td>
                                                                    <div className="form-check font-size-16">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`instanceCheck${index}`}
                                                                            disabled={isReversed}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor={`instanceCheck${index}`}
                                                                        ></label>
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">
                                                                    {index + 1}

                                                                </td>
                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted text-start narration-cell' : 'text-start narration-cell'}
                                                                    title={expense.narration || ""}>
                                                                    {expense.narration || ""}
                                                                </td>
                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted' : ''}>
                                                                    {formatDate(expense.date)}
                                                                </td>

                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted narration-cell text-start' : 'text-start narration-cell'} title={expense.expense_type?.name}>
                                                                    {expense.expense_type?.name}
                                                                </td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense?.client?.name || expense?.vendor?.name || expense.payroll_provider_name}</td>


                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.project?.name}</td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.user?.name}</td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.tax_type}</td>
                                                                <td className={`${isReversed ? 'text-muted' : ''} text-end fw-bold`} style={{ 
                                                                    color: (!isReversed) ? (
                                                                        expense.payment_status === 'Paid' ? '#198754' : 
                                                                        expense.payment_status === 'Unpaid' ? '#dc3545' : 
                                                                        '#ffc107' // Orange/Yellow for Partial
                                                                    ) : 'inherit'
                                                                }}>
                                                                    {formatUSCurrency(
                                                                        expense.grand_total || (expense.tax_type === 'taxable' ? expense.total_amount : expense.amount)
                                                                    )}
                                                                    <span className="text-muted ms-1 font-size-11 fw-normal">
                                                                        ({expense.vendor_currency})
                                                                    </span>
                                                                </td>
                                                                <td className="text-end">
                                                                    <div className="dropdown">
                                                                        {isReversed ? (
                                                                            // Show disabled three dots for reversed expenses
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18 text-muted"
                                                                                style={{
                                                                                    cursor: 'not-allowed',
                                                                                    opacity: 0.5
                                                                                }}
                                                                                title="Reversed - Actions disabled"
                                                                            ></i>
                                                                        ) : (
                                                                            // Show normal dropdown for non-reversed expenses
                                                                            <>
                                                                                <i
                                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                                    data-bs-toggle="dropdown"
                                                                                    aria-expanded="false"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                ></i>
                                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                    <li>
                                                                                        <WithEditPermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowModal(expense.id, "edit")}
                                                                                            >
                                                                                                Edit
                                                                                            </button>
                                                                                        </WithEditPermission>
                                                                                    </li>
                                                                                    <li>
                                                                                        <WithDeletePermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => deleteExpense(expense.id)}
                                                                                            >
                                                                                                Delete
                                                                                            </button>
                                                                                        </WithDeletePermission>
                                                                                    </li>
                                                                                </ul>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="11">No expenses available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                forcePage={currentPage - 1}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ExpenseModal
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        expenseId={selectedExpenseId}
                        expenseData={selectedExpenseData}
                        addExpense={addExpense}
                        editExpense={editExpense}
                        errors={errors}
                        setErrors={setErrors}
                        fetchExpenseTypes={fetchExpenseTypes}
                        expenseTypes={expenseTypes}
                        fetchUsers={fetchUsers}
                        users={users}
                        isEditMode={isEditMode}
                        setIsEditMode={setIsEditMode}
                    />
                </div>
            </div >
        </div >

    );
};
export default AllExpenseList;










